webpackJsonp([122],{

/***/ 1160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderImageRecaptureDetectionImageTable_vue__ = __webpack_require__(2799);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f781d4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderImageRecaptureDetectionImageTable_vue__ = __webpack_require__(4646);
function injectStyle (ssrContext) {
  __webpack_require__(4636)
  __webpack_require__(4638)
  this["$style"] = __webpack_require__(4640)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f781d4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderImageRecaptureDetectionImageTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f781d4e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderImageRecaptureDetectionImageTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(104);
var wksExt = __webpack_require__(1350);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(244);
var hiddenKeys = __webpack_require__(148).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1365);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1366);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(235);
var createDesc = __webpack_require__(103);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(243);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(234);
module.exports = __webpack_require__(1350).f('iterator');


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1370);
__webpack_require__(241);
__webpack_require__(1373);
__webpack_require__(1374);
module.exports = __webpack_require__(12).Symbol;


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(245);
var META = __webpack_require__(1353).KEY;
var $fails = __webpack_require__(76);
var shared = __webpack_require__(147);
var setToStringTag = __webpack_require__(105);
var uid = __webpack_require__(144);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(1350);
var wksDefine = __webpack_require__(1351);
var enumKeys = __webpack_require__(1371);
var isArray = __webpack_require__(1356);
var anObject = __webpack_require__(41);
var isObject = __webpack_require__(55);
var toObject = __webpack_require__(78);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var createDesc = __webpack_require__(103);
var _create = __webpack_require__(240);
var gOPNExt = __webpack_require__(1372);
var $GOPD = __webpack_require__(1367);
var $GOPS = __webpack_require__(237);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1354).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(235).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(104)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(237);
var pIE = __webpack_require__(235);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(1354).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('asyncIterator');


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('observable');


/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),

/***/ 1529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fabric__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fabric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fabric__);

// 兼容 CDN fabric.min
var fabric = __WEBPACK_IMPORTED_MODULE_0_fabric___default.a.fabric || __WEBPACK_IMPORTED_MODULE_0_fabric___default.a;
/* harmony default export */ __webpack_exports__["a"] = (fabric);

/***/ }),

/***/ 1567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main__ = __webpack_require__(1716);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);

/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1739);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("82785c9c", content, true, {});

/***/ }),

/***/ 1578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vendor_fabric__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_viewerjs_viewer_esm_js__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LableResult__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DrawOverlayCanvas_vue__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DrawToolbar_vue__ = __webpack_require__(1727);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [],
  components: { DrawOverlayCanvas: __WEBPACK_IMPORTED_MODULE_10__DrawOverlayCanvas_vue__["a" /* default */], DrawToolbar: __WEBPACK_IMPORTED_MODULE_11__DrawToolbar_vue__["a" /* default */] },
  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    },
    visible: {
      type: Boolean,
      default: false
    },
    toolbar: {
      type: Object,
      default: {}
    },
    getLableData: Function,
    orderId: {
      type: [Number, String],
      default: null
    }
  },
  data: function data() {
    return {
      viewer: null,
      loading: false,
      lableData: {},
      visibleLabel: false,
      imgrHost: window._env_.VUE_APP_IMGR_HOST,
      viewIndex: 0,
      preIndex: -1,
      preFiles: [],
      liWidth: 60,
      ulTransform: 0,
      suffix: '?x-oss-process=image/resize,m_pad,h_55,w_55,color_FFFFFF',
      // 此处无法使用 auto-orient，因极高品质会超过4096
      autoOrientSuffix: '?x-oss-process=image/resize,l_4096',

      drawMode: false,
      drawTool: 'select',
      drawStroke: '#ff0000',
      drawStrokeWidth: 3,
      drawSaving: false,
      drawCanUndo: false,
      drawCanRedo: false,
      drawOverlayStyle: {},
      drawOverlayCanvasWidth: 0,
      drawOverlayCanvasHeight: 0,
      drawRotation: 0
    };
  },

  computed: {
    ulWidth: function ulWidth() {
      return this.liWidth * this.files.length;
    },
    src: function src() {
      return this.files[this.viewIndex].src;
    },
    preSrc: function preSrc() {
      if (this.preIndex !== -1) {
        return this.preFiles[this.preIndex].src;
      }
      return '';
    },
    lastToolbar: function lastToolbar() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
        zoomIn: true,
        zoomOut: true,
        oneToOne: true,
        reset: true,
        prev: true,
        next: true,
        rotateLeft: true,
        rotateRight: true,
        label: false,
        delete: false,
        download: true
      }, this.toolbar);
    },
    showDrawButton: function showDrawButton() {
      return !!this.orderId;
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        // 显示当前图片
        this.view(this.index);
      } else {
        this.exitDrawMode(true);
        // 关闭预加载
        this.preIndex = -1;
        this.preFiles = [];
        // 销毁查看器
        this.viewer.destroy();
        this.viewer = null;
      }
      this.listenerKeyboard();
    }
  },
  created: function created() {
    this.view(this.index);
    this.listenerKeyboard();
    this.$nextTick(function () {});
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    if (this.drawSaving) {
      this.setDrawSaving(false);
    }
  },

  methods: {
    initViewer: function initViewer(initialViewIndex) {
      var _this = this;

      this.viewer = new __WEBPACK_IMPORTED_MODULE_7__vendor_viewerjs_viewer_esm_js__["a" /* default */](this.$refs.images, {
        initialViewIndex: initialViewIndex,
        inline: true,
        button: false,
        navbar: false,
        title: false,
        // backdrop: false,
        toolbar: false,
        url: function url(image) {
          return filter.ossHost(image.src.replace(_this.suffix, ''), _this.autoOrientSuffix);
        },
        ready: function ready() {
          // 预加载下一张图片
          _this.nextPreIndex();
        },
        view: function view() {
          _this.$emit('label');
        },
        viewed: function viewed() {
          _this.$nextTick(_this.onLabel);
        }
      });
    },
    setDrawTool: function setDrawTool(tool) {
      this.drawTool = tool;
    },
    setDrawSaving: function setDrawSaving(saving) {
      saving = !!saving;
      this.drawSaving = saving;
      this.$emit('draw-saving-change', saving);
    },
    onHistoryChange: function onHistoryChange() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          canUndo = _ref.canUndo,
          canRedo = _ref.canRedo;

      this.drawCanUndo = !!canUndo;
      this.drawCanRedo = !!canRedo;
    },
    onUndo: function onUndo() {
      if (!this.drawMode) return;
      if (!this.$refs.drawOverlay || !this.$refs.drawOverlay.undo) return;
      this.$refs.drawOverlay.undo();
    },
    onRedo: function onRedo() {
      if (!this.drawMode) return;
      if (!this.$refs.drawOverlay || !this.$refs.drawOverlay.redo) return;
      this.$refs.drawOverlay.redo();
    },
    onDrawRotate: function onDrawRotate(degree) {
      var _this2 = this;

      if (!this.drawMode || !this.viewer) return;
      this.viewer.rotate(degree);
      // 旋转后适配可见区域；标注层只改 CSS（旋转+外框尺寸），不重绘 fabric 对象
      this.fitDrawImageInView();
      this.syncDrawOverlayToViewer();
      this.$nextTick(function () {
        if (_this2.$refs.drawOverlay && _this2.$refs.drawOverlay.canvas && _this2.$refs.drawOverlay.canvas.calcOffset) {
          _this2.$refs.drawOverlay.canvas.calcOffset();
        }
      });
    },


    /**
     * 按当前旋转角度，把图片（含 CSS 旋转后的可视宽高）完整适配进 viewer 可见区域
     * 预留 2px 并向下取整，避免旋转后 AABB 因亚像素/取整超出 viewer-canvas 被裁边
     */
    fitDrawImageInView: function fitDrawImageInView() {
      if (!this.viewer || !this.viewer.imageData || !this.viewer.viewerData) return;
      var imageData = this.viewer.imageData;
      var viewerData = this.viewer.viewerData;
      var naturalWidth = imageData.naturalWidth;
      var naturalHeight = imageData.naturalHeight;
      if (!naturalWidth || !naturalHeight) return;

      var rotate = this.normalizeDrawRotation(imageData.rotate);
      var isQuarterTurn = rotate === 90 || rotate === 270;
      // 90/270 时可视宽高对调
      var visualNaturalWidth = isQuarterTurn ? naturalHeight : naturalWidth;
      var visualNaturalHeight = isQuarterTurn ? naturalWidth : naturalHeight;
      // 与 viewer-canvas overflow:hidden 对齐：略缩小可用区，杜绝贴边被裁 1px
      var fitPad = 2;
      var availWidth = Math.max(viewerData.width - fitPad, 1);
      var availHeight = Math.max(viewerData.height - fitPad, 1);
      var fitRatio = Math.min(availWidth / visualNaturalWidth, availHeight / visualNaturalHeight);
      if (!fitRatio || !isFinite(fitRatio)) return;

      // layout 尺寸仍按未旋转坐标系，显示靠 CSS rotate；floor 保证旋转后可视边不超过 avail*
      var newWidth = Math.floor(naturalWidth * fitRatio);
      var newHeight = Math.floor(naturalHeight * fitRatio);
      if (!newWidth || !newHeight) return;
      imageData.width = newWidth;
      imageData.height = newHeight;
      imageData.ratio = newWidth / naturalWidth;
      imageData.left = (viewerData.width - newWidth) / 2;
      imageData.top = (viewerData.height - newHeight) / 2;

      if (typeof this.viewer.renderImage === 'function') {
        this.viewer.renderImage();
      }
    },
    normalizeDrawRotation: function normalizeDrawRotation(degree) {
      return (degree % 360 + 360) % 360;
    },
    getBackgroundSrcForExport: function getBackgroundSrcForExport() {
      var file = this.files[this.viewIndex] || {};
      var src = file.src || '';
      if (!src) return '';
      var normalizedSrc = this.suffix && src.includes(this.suffix) ? src.replace(this.suffix, '') : src;
      return filter.ossHost(normalizedSrc, this.autoOrientSuffix);
    },


    /** 协议相对地址（//xxx）在部分环境下 fetch/axios 表现不稳定，统一为绝对地址 */
    resolveAbsoluteMediaUrl: function resolveAbsoluteMediaUrl(url) {
      if (!url) return '';
      if (url.indexOf('//') === 0) {
        return window.location.protocol + url;
      }
      return url;
    },


    /**
     * 拉取 OSS 图片二进制。浏览器直连 OSS 受 CORS 限制时无法读响应体；
     * 优先走后端同源代理（与财务 getFinCenterFileUrlForDownload 同路径），由服务端代拉 OSS。
     */
    fetchRemoteImageBlob: function fetchRemoteImageBlob(url) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var absoluteUrl, proxyBases, i, proxyUrl, _ref2, data, http, _ref3, _data, res;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                absoluteUrl = _this3.resolveAbsoluteMediaUrl(url);
                proxyBases = [window._env_.VUE_APP_FIN_CENTER_HOST, window._env_.VUE_APP_ADMIN_HOST].filter(Boolean);
                i = 0;

              case 3:
                if (!(i < proxyBases.length)) {
                  _context.next = 18;
                  break;
                }

                proxyUrl = proxyBases[i] + '/oss_file_download?name=file&type=pic&url=' + encodeURIComponent(absoluteUrl);
                _context.prev = 5;
                _context.next = 8;
                return axios.get(proxyUrl, {
                  responseType: 'blob',
                  timeout: 120000,
                  maxContentLength: Infinity,
                  maxBodyLength: Infinity
                });

              case 8:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data);

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](5);

              case 15:
                i++;
                _context.next = 3;
                break;

              case 18:
                http = axios.create();
                _context.prev = 19;
                _context.next = 22;
                return http.get(absoluteUrl, {
                  responseType: 'blob',
                  timeout: 120000,
                  maxContentLength: Infinity,
                  maxBodyLength: Infinity
                });

              case 22:
                _ref3 = _context.sent;
                _data = _ref3.data;
                return _context.abrupt('return', _data);

              case 27:
                _context.prev = 27;
                _context.t1 = _context['catch'](19);
                _context.next = 31;
                return fetch(absoluteUrl, {
                  credentials: 'omit',
                  mode: 'cors'
                });

              case 31:
                res = _context.sent;

                if (res.ok) {
                  _context.next = 34;
                  break;
                }

                throw _context.t1;

              case 34:
                return _context.abrupt('return', res.blob());

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 13], [19, 27]]);
      }))();
    },
    syncDrawOverlayToViewer: function syncDrawOverlayToViewer() {
      if (!this.viewer || !this.viewer.imageData) return;
      var imageData = this.viewer.imageData;
      var rotate = Number(imageData.rotate) || 0;
      this.drawRotation = this.normalizeDrawRotation(rotate);
      var nextWidth = Math.round(imageData.width || 0);
      var nextHeight = Math.round(imageData.height || 0);

      // fabric 内部坐标系只在进入标注时初始化一次；之后只同步外层 CSS
      // 这样旋转时整块 canvas（含已画的框）直接 CSS rotate，无对象重绘延迟
      if (!this.drawOverlayCanvasWidth || !this.drawOverlayCanvasHeight) {
        this.drawOverlayCanvasWidth = nextWidth;
        this.drawOverlayCanvasHeight = nextHeight;
      }

      this.drawOverlayStyle = {
        position: 'absolute',
        left: Math.round(imageData.left || 0) + 'px',
        top: Math.round(imageData.top || 0) + 'px',
        width: nextWidth + 'px',
        height: nextHeight + 'px',
        transform: rotate ? 'rotate(' + rotate + 'deg)' : 'none',
        transformOrigin: 'center center',
        pointerEvents: 'auto'
      };
    },
    enterDrawMode: function enterDrawMode() {
      var _this4 = this;

      if (this.drawMode) return;
      if (!this.showDrawButton) {
        this.$message.warning('当前为只读模式，不可操作');
        return;
      }
      this.drawMode = true;
      this.drawTool = 'rect';
      this.drawSaving = false;
      this.drawCanUndo = false;
      this.drawCanRedo = false;
      this.drawRotation = 0;
      // 清空以便重新锁定本次标注的 fabric 尺寸
      this.drawOverlayCanvasWidth = 0;
      this.drawOverlayCanvasHeight = 0;
      this.drawOverlayStyle = {};

      if (this.viewer && this.viewer.canvas) {
        this.viewer.canvas.style.pointerEvents = 'none';
      }
      if (this.viewer && this.viewer.viewer) {
        this.viewer.viewer.style.pointerEvents = 'none';
      }

      if (this.viewer && this.viewer.reset) {
        this.viewer.reset();
      }

      this.$nextTick(function () {
        // 先清空旧标注，再锁定新尺寸，避免旧对象被短暂拉伸
        if (_this4.$refs.drawOverlay && _this4.$refs.drawOverlay.reset) {
          _this4.$refs.drawOverlay.reset();
        }
        _this4.syncDrawOverlayToViewer();
        _this4.$nextTick(function () {
          if (_this4.$refs.drawOverlay && _this4.$refs.drawOverlay.canvas && _this4.$refs.drawOverlay.canvas.calcOffset) {
            _this4.$refs.drawOverlay.canvas.calcOffset();
          }
        });
      });
    },
    onDrawSave: function onDrawSave() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var hasDrawn, hasRotation, confirmText;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this5.drawMode || _this5.drawSaving)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                if (_this5.$refs.drawOverlay) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                hasDrawn = _this5.$refs.drawOverlay.hasDrawn && _this5.$refs.drawOverlay.hasDrawn();
                hasRotation = _this5.normalizeDrawRotation(_this5.drawRotation) !== 0;
                // 画了标注，或仅旋转，都应保存生效

                if (!(!hasDrawn && !hasRotation)) {
                  _context3.next = 9;
                  break;
                }

                _this5.exitDrawMode(true);
                return _context3.abrupt('return');

              case 9:
                confirmText = hasDrawn ? '已记录退回标记内容，请确认保存？' : '已记录旋转后的图片内容，请确认保存更新？';

                _this5.$confirm(confirmText, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                  var backgroundSrc, imageData, naturalWidth, naturalHeight, backgroundBlob, backgroundUrl, backgroundImg, overlayImg, overlayDataUrl, rotation, isQuarterTurn, outputWidth, outputHeight, canvas, ctx, blob, ext, url, res, uploadUrl, contentType, fileUrl, file;
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;

                          _this5.setDrawSaving(true);
                          backgroundSrc = _this5.getBackgroundSrcForExport();

                          if (backgroundSrc) {
                            _context2.next = 5;
                            break;
                          }

                          throw new Error('导出数据缺失');

                        case 5:
                          imageData = _this5.viewer && _this5.viewer.imageData || {};
                          naturalWidth = imageData.naturalWidth;
                          naturalHeight = imageData.naturalHeight;

                          if (!(!naturalWidth || !naturalHeight)) {
                            _context2.next = 10;
                            break;
                          }

                          throw new Error('获取图片尺寸失败');

                        case 10:
                          _context2.next = 12;
                          return _this5.fetchRemoteImageBlob(backgroundSrc);

                        case 12:
                          backgroundBlob = _context2.sent;
                          backgroundUrl = URL.createObjectURL(backgroundBlob);
                          _context2.next = 16;
                          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            var img = new Image();
                            img.onload = function () {
                              return resolve(img);
                            };
                            img.onerror = function (e) {
                              return reject(e);
                            };
                            img.src = backgroundUrl;
                          });

                        case 16:
                          backgroundImg = _context2.sent;


                          // 2) 如有标注再加载 overlay；仅旋转时跳过
                          overlayImg = null;

                          if (!hasDrawn) {
                            _context2.next = 27;
                            break;
                          }

                          _context2.next = 21;
                          return _this5.$refs.drawOverlay.getOverlayDataUrl();

                        case 21:
                          overlayDataUrl = _context2.sent;

                          if (overlayDataUrl) {
                            _context2.next = 24;
                            break;
                          }

                          throw new Error('导出数据缺失');

                        case 24:
                          _context2.next = 26;
                          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            var img = new Image();
                            img.onload = function () {
                              return resolve(img);
                            };
                            img.onerror = function (e) {
                              return reject(e);
                            };
                            img.src = overlayDataUrl;
                          });

                        case 26:
                          overlayImg = _context2.sent;

                        case 27:
                          rotation = _this5.normalizeDrawRotation(_this5.drawRotation);
                          isQuarterTurn = rotation === 90 || rotation === 270;
                          outputWidth = isQuarterTurn ? naturalHeight : naturalWidth;
                          outputHeight = isQuarterTurn ? naturalWidth : naturalHeight;
                          canvas = document.createElement('canvas');

                          canvas.width = outputWidth;
                          canvas.height = outputHeight;
                          ctx = canvas.getContext('2d');

                          ctx.save();
                          if (rotation === 90) {
                            ctx.translate(outputWidth, 0);
                            ctx.rotate(Math.PI / 2);
                          } else if (rotation === 180) {
                            ctx.translate(outputWidth, outputHeight);
                            ctx.rotate(Math.PI);
                          } else if (rotation === 270) {
                            ctx.translate(0, outputHeight);
                            ctx.rotate(Math.PI * 1.5);
                          }
                          // 背景与标注处于同一未旋转坐标系，一起旋转后合成
                          ctx.drawImage(backgroundImg, 0, 0, naturalWidth, naturalHeight);
                          if (overlayImg) {
                            ctx.drawImage(overlayImg, 0, 0, naturalWidth, naturalHeight);
                          }
                          ctx.restore();

                          _context2.next = 42;
                          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                            canvas.toBlob(function (b) {
                              return resolve(b);
                            }, 'image/jpeg', 0.92);
                          });

                        case 42:
                          blob = _context2.sent;


                          URL.revokeObjectURL(backgroundUrl);

                          if (blob) {
                            _context2.next = 46;
                            break;
                          }

                          throw new Error('图片合成失败');

                        case 46:
                          ext = blob.type ? blob.type.split('/').pop() : 'jpg';
                          url = _this5.src + '.annotation.' + ext;
                          _context2.next = 50;
                          return request.common('uploadOrderReviewDirectFile', {
                            ext: ext,
                            content_type: blob.type || 'image/jpeg',
                            url: url
                          });

                        case 50:
                          res = _context2.sent;
                          uploadUrl = res.data.signedUrl;
                          contentType = res.data.content_type;
                          _context2.next = 55;
                          return fetch(uploadUrl, {
                            method: 'PUT',
                            headers: new Headers({
                              'Content-Type': contentType
                            }),
                            body: blob
                          });

                        case 55:
                          fileUrl = res.data.url;
                          file = _this5.files[_this5.viewIndex];

                          file.src = fileUrl;
                          _this5.$emit('draw-saved', {
                            src: fileUrl,
                            index: _this5.viewIndex
                          });
                          // 等一次 $nextTick() 再解锁，避免外部审核结果还没同步就被关掉
                          _context2.next = 61;
                          return _this5.$nextTick();

                        case 61:
                          _this5.refreshCurrentViewerImage();
                          _this5.$message.success('标注图片已保存');
                          _this5.exitDrawMode(true);
                          _context2.next = 69;
                          break;

                        case 66:
                          _context2.prev = 66;
                          _context2.t0 = _context2['catch'](0);

                          _this5.$message.error('保存失败');

                        case 69:
                          _context2.prev = 69;

                          _this5.setDrawSaving(false);
                          return _context2.finish(69);

                        case 72:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this5, [[0, 66, 69, 72]]);
                }))).catch(function () {});

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    onDrawCancel: function onDrawCancel() {
      var _this6 = this;

      if (!this.drawMode) return;
      this.$confirm('退出画图并丢弃本次绘制吗？', '提示', {
        confirmButtonText: '丢弃',
        cancelButtonText: '继续画',
        type: 'warning'
      }).then(function () {
        _this6.exitDrawMode(true);
      }).catch(function () {});
    },
    onStrokeChange: function onStrokeChange(val) {
      if (!this.drawMode) return;
      this.drawStroke = val;
    },
    refreshCurrentViewerImage: function refreshCurrentViewerImage() {
      var _this7 = this;

      this.$nextTick(function () {
        if (!_this7.viewer) return;
        if (_this7.viewer.update) {
          _this7.viewer.update();
        }
        if (_this7.viewer.view) {
          _this7.viewer.view(_this7.viewIndex);
        }
      });
    },
    exitDrawMode: function exitDrawMode(restoreViewer) {
      if (!this.drawMode) return;
      this.drawMode = false;
      this.drawTool = 'select';
      this.drawRotation = 0;
      this.drawOverlayCanvasWidth = 0;
      this.drawOverlayCanvasHeight = 0;
      this.drawOverlayStyle = {};
      if (restoreViewer && this.viewer && this.viewer.canvas) {
        this.viewer.canvas.style.pointerEvents = '';
      }
      if (restoreViewer && this.viewer && this.viewer.viewer) {
        this.viewer.viewer.style.pointerEvents = '';
      }
      if (this.$refs.drawOverlay && this.$refs.drawOverlay.discardChanges) {
        this.$refs.drawOverlay.discardChanges();
      }
    },
    nextPreIndex: function nextPreIndex() {
      // 仅显示时预加载图片
      if (this.visible) {
        // 预设初始值
        if (this.preIndex === -1) {
          // 生成预加载文件列表
          this.preFiles = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(this.index)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.files.slice(0, this.index)));
          this.preIndex = 0;
          return;
        }
        // 递增
        if (this.preIndex < this.preFiles.length - 1) {
          this.preIndex++;
        }
      }
    },
    listenerKeyboard: function listenerKeyboard() {
      if (this.visible) {
        document.addEventListener('keydown', this.keyboard);
      } else {
        document.removeEventListener('keydown', this.keyboard);
      }
    },
    keyboard: function keyboard(e) {
      var code = e.keyCode || e.which || e.charCode;
      if (this.drawMode) {
        var isCtrl = e.ctrlKey || e.metaKey;
        var overlay = this.$refs.drawOverlay;

        // 输入文字时，只处理撤销/重做等快捷键
        if (overlay && overlay.isTextEditing && overlay.isTextEditing() && !isCtrl) return;

        // Ctrl/Cmd + Z => Undo；Ctrl/Cmd + Shift + Z 或 Ctrl/Cmd + Y => Redo
        if (isCtrl && (code === 90 || e.key === 'z' || e.key === 'Z')) {
          if (e.shiftKey) {
            this.onRedo();
          } else {
            this.onUndo();
          }
          e.preventDefault();
          return;
        }
        if (isCtrl && (code === 89 || e.key === 'y' || e.key === 'Y')) {
          this.onRedo();
          e.preventDefault();
          return;
        }

        // 工具切换快捷键（不显示“拖动”，但保留选择态 via ESC/V）
        // 1: 矩形；2: 椭圆/圆形（按住 Shift 画圆）；3: 自由绘画；4: 文字
        if (!e.altKey && !isCtrl) {
          switch (code) {
            case 27:
              // ESC
              this.setDrawTool('select');
              break;
            case 49:
              // 1
              this.setDrawTool('rect');
              break;
            case 50:
              // 2
              this.setDrawTool('ellipse');
              break;
            case 51:
              // 3
              this.setDrawTool('free');
              break;
            case 52:
              // 4
              this.setDrawTool('text');
              break;
            case 53:
              // 5
              this.setDrawTool('arrow');
              break;
            case 86:
              // V
              this.setDrawTool('select');
              break;
            case 87:
              // W
              this.onDrawRotate(-90);
              break;
            case 83:
              // S
              this.onDrawRotate(90);
              break;
          }
        }
        return;
      }

      switch (code) {
        // A
        case 65:
          this.onPrev();
          break;
        // D
        case 68:
          this.onNext();
          break;
        // W
        case 87:
          this.onRotate(-90);
          break;
        // S
        case 83:
          this.onRotate(90);
          break;
      }
    },
    view: function view(index) {
      var _this8 = this;

      if (__WEBPACK_IMPORTED_MODULE_9__LableResult__["a" /* default */].isInstance()) {
        __WEBPACK_IMPORTED_MODULE_9__LableResult__["a" /* default */].destroy();
        this.lableInit = null;
        this.visibleLabel = false;
        this.loading = false;
      }
      if (index < 0) {
        index = 0;
      }
      if (index >= this.files.length) {
        index = this.files.length - 1;
      }
      this.viewIndex = index;
      this.$emit('changeIndex', index);
      this.$nextTick(function () {
        _this8.transform();
        if (_this8.viewer) {
          _this8.viewer.update();
          _this8.viewer.view(index);
        } else {
          _this8.initViewer(index);
        }
      });
    },
    transform: function transform() {
      this.ulTransform = (this.$el.offsetWidth - this.liWidth) / 2 - this.liWidth * this.viewIndex;
    },
    onZoom: function onZoom(ratio) {
      this.viewer.zoom(ratio);
    },
    onOneToOne: function onOneToOne() {
      this.viewer.toggle();
    },
    onPrev: function onPrev() {
      this.view(this.viewIndex - 1);
    },
    onNext: function onNext() {
      this.view(this.viewIndex + 1);
    },
    onReset: function onReset() {
      this.viewer.reset();
    },
    onRotate: function onRotate(degree) {
      if (this.drawMode) {
        this.onDrawRotate(degree);
        return;
      }
      this.viewer.rotate(degree);
    },
    onDelete: function onDelete() {
      var files = this.files,
          viewIndex = this.viewIndex;

      if (files.length > 1) {
        files.splice(viewIndex, 1);
        this.view(viewIndex);
      }
    },
    onDownload: function onDownload() {
      var src = this.files[this.viewIndex].src;
      // 替换掉 http, 防止出现 https 向 http 请求的错误

      __WEBPACK_IMPORTED_MODULE_8_downloadjs___default()(filter.ossHost(src));
    },
    getTransform: function getTransform(targetNode) {
      var transform = $(targetNode).css('transform');
      var left = parseFloat($(targetNode).css('margin-left'));
      var top = parseFloat($(targetNode).css('margin-top'));
      var matrix = [1, 0, 0, 1, 0, 0];
      if (transform !== 'none') {
        matrix = transform.slice(7, transform.length - 1).split(', ');
      }
      if (targetNode.naturalWidth !== targetNode.width || targetNode.naturalHeight !== targetNode.height) {
        matrix = __WEBPACK_IMPORTED_MODULE_5__vendor_fabric__["a" /* default */].util.multiplyTransformMatrices(matrix, [targetNode.width / targetNode.naturalWidth, 0, 0, targetNode.height / targetNode.naturalHeight, 0, 0], false);
        left -= (targetNode.naturalWidth - targetNode.width) / 2;
        top -= (targetNode.naturalHeight - targetNode.height) / 2;
      }
      return { left: left, top: top, matrix: matrix };
    },
    loadLableResult: function loadLableResult(src) {
      var _this9 = this;

      var container = $('.view-content .viewer-canvas')[0];
      var img = $('img', container)[0];

      var init = function init() {
        var _getTransform = _this9.getTransform(img),
            left = _getTransform.left,
            top = _getTransform.top,
            matrix = _getTransform.matrix;

        Object(__WEBPACK_IMPORTED_MODULE_9__LableResult__["a" /* default */])(container).init(_this9.lableData[src], left, top, matrix).show();
      };

      var mutationObserver = function mutationObserver() {
        // Select the node that will be observed for mutations
        var targetNode = img;

        // Options for the observer (which mutations to observe)
        var config = {
          attributes: true
          // childList: true,
          // subtree: true
        };

        var changeCount = 0;
        var lastCSSText = img.style.cssText;
        // Callback function to execute when mutations are observed
        var mutationCallback = function mutationCallback(mutationsList) {
          if (lastCSSText === img.style.cssText) {
            return false;
          }
          changeCount++;
          __WEBPACK_IMPORTED_MODULE_9__LableResult__["a" /* default */].hide();
          lastCSSText = img.style.cssText;
          // 记录本次缓存的数据已变化次数
          var updateCount = changeCount;
          // 延迟300毫秒保存数据
          setTimeout(function () {
            // 数据还处于变化中，等待变化完毕后执行缓存
            if (updateCount === changeCount) {
              var _getTransform2 = _this9.getTransform(img),
                  left = _getTransform2.left,
                  top = _getTransform2.top,
                  matrix = _getTransform2.matrix;

              Object(__WEBPACK_IMPORTED_MODULE_9__LableResult__["a" /* default */])(container).update(left, top, matrix).show();
            }
          }, 400);
        };

        // Create an observer instance linked to the callback function
        _this9.observer = new MutationObserver(mutationCallback);

        // Start observing the target node for configured mutations
        _this9.observer.observe(targetNode, config);
      };

      this.visibleLabel = !this.visibleLabel;
      if (this.visibleLabel) {
        if (this.lableInit) {
          var _getTransform3 = this.getTransform(img),
              left = _getTransform3.left,
              top = _getTransform3.top,
              matrix = _getTransform3.matrix;

          Object(__WEBPACK_IMPORTED_MODULE_9__LableResult__["a" /* default */])(container).update(left, top, matrix).show();
          mutationObserver();
        } else {
          init();
          mutationObserver();
          this.lableInit = true;
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_9__LableResult__["a" /* default */].hide();
        // Later, you can stop observing
        this.observer.disconnect();
      }
    },
    onLabel: function onLabel() {
      var _this10 = this;

      if (this.lastToolbar.label && this.getLableData) {
        var src = this.files[this.viewIndex].src;


        if (this.lableData.hasOwnProperty(src)) {
          this.loadLableResult(src);
          this.$emit('labeled');
        } else {
          this.loading = true;
          this.getLableData(src).then(function (_ref5) {
            var data = _ref5.data;

            if (data) {
              _this10.lableData[src] = data;
              _this10.onLabel();
            }
          }).finally(function () {
            _this10.loading = false;
          });
        }
      }
    }
  }
});

/***/ }),

/***/ 1579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(1720);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      data: null,
      canvasData: null,
      canvas: null,
      visible: false,
      isDestroy: false,
      popoverVisible: false,
      // products: [],
      selectedProduct: null,
      left: 0,
      top: 0,
      matrix: [1, 0, 0, 1, 0, 0],
      width: 0,
      height: 0,
      color: {
        default: {
          fill: 'rgba(64, 158, 255, 0.05)',
          stroke: 'rgba(64, 158, 255)',
          strokeWidth: 1
        },
        hover: {
          fill: 'rgba(255, 64, 64, 0.05)',
          stroke: 'rgba(255, 64, 64)',
          strokeWidth: 2
        },
        active: {
          fill: 'rgba(64, 255, 64, 0.05)',
          stroke: 'rgba(64, 255, 64)',
          strokeWidth: 2
        }
      },
      predefineColors: ['rgba(64, 158, 255)', 'rgba(255, 64, 64)', 'rgba(64, 255, 64)'],
      angle: 0,
      scaleX: 1,
      scaleY: 1,
      selectedPathData: {
        id: '',
        name: '',
        number: ''
      },
      feedbackExceptionloading: false
    };
  },

  computed: {},
  watch: {
    matrix: function matrix() {
      var options = __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__["a" /* default */].util.qrDecompose(this.matrix);
      this.angle = options.angle;
      this.scaleX = options.scaleX;
      this.scaleY = options.scaleY;
    },
    visible: function visible(val) {
      if (!val) {
        this.popoverVisible = false;
      }
    }
  },
  created: function created() {},
  destroyed: function destroyed() {},

  methods: {
    init: function init() {
      var _this = this;

      this.isDestroy = false;
      var data = filter.copyJson(this.data);
      this.canvasData = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* toLabelData */])(data.labels, data.width, data.height);
      this.$nextTick(function () {
        // this.products = data.products.filter(o => o.total > 0)
        _this.loadCanvas();
        _this.loadGraphicsPath();
        _this.canvas.renderAll();
      });
    },
    destroy: function destroy() {
      this.isDestroy = true;
    },
    update: function update() {
      if (this.canvasData.data.length) {
        var canvas = this.canvas;
        canvas.clear();
        this.loadGraphicsPath();
        canvas.renderAll();
      }
    },
    loadCanvas: function loadCanvas() {
      this.canvas = new __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__["a" /* default */].Canvas('canvas', {
        selection: false,
        hoverCursor: 'auto',
        selectable: false,
        evented: false
        // backgroundColor: 'beige'
      });
      // canvas.on('mouse:move', (e) => {
      //   // console.log('mouse:move')
      // })
      // canvas.on('mouse:down', (e) => {
      //   // console.log('mouse:down')
      // })
      // canvas.on('mouse:up', (e) => {
      // //   console.log('mouse:up')
      // })
      // canvas.on('mouse:over', (e) => {
      // })
      // canvas.on('mouse:out', (e) => {
      // })
    },
    loadGraphicsPath: function loadGraphicsPath() {
      var _this2 = this;

      var canvas = this.canvas;
      var canvasData = this.canvasData;
      var region = new __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__["a" /* default */].Rect({
        width: canvasData.width,
        height: canvasData.height,
        fill: 'transparent',
        stroke: 'transparent',
        hoverCursor: 'auto',
        selectable: false,
        evented: false
      });
      canvas.add(region);
      canvasData.data.map(function (data, index) {
        var path = new __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__["a" /* default */].Path(data.SVGPath);
        path.set({
          fill: _this2.color.default.fill,
          stroke: _this2.color.default.stroke,
          strokeWidth: _this2.color.default.strokeWidth,
          hoverCursor: 'pointer',
          selectable: false,
          evented: true,
          data: data,
          index: index
        });
        _this2.registerPathEvent(path);
        canvas.add(path);
        return path;
      });
      this.showSelectProductPath();
      this.transform();
    },
    registerPathEvent: function registerPathEvent(path) {
      var _this3 = this;

      var canvas = this.canvas;
      path.on('mouseover', function (e) {
        // console.log('mouseover')
        if (_this3.visible && e.target) {
          var style = _this3.$refs.popover.style;
          var target = e.target;
          _this3.selectedPathData.id = e.target.data.id;
          _this3.selectedPathData.name = e.target.data.product.name;
          _this3.selectedPathData.number = e.target.data.product.number;
          style.left = target.data.realPath[0] + 'px';
          style.top = target.data.realPath[1] + 'px';
          style.width = target.width + 2 + 'px';
          style.height = target.height + 2 + 'px';
          _this3.$nextTick(function () {
            _this3.popoverVisible = true;
          });
          e.target.set('stroke', _this3.color.hover.stroke);
          e.target.set('strokeWidth', _this3.color.hover.strokeWidth);
          canvas.renderAll();
        }
      });
      path.on('mouseout', function (e) {
        if (_this3.visible && e.target) {
          _this3.popoverVisible = false;
          e.target.set('stroke', _this3.color.default.stroke);
          e.target.set('strokeWidth', _this3.color.default.strokeWidth);
          canvas.renderAll();
        }
      });
    },
    makeActiveSelection: function makeActiveSelection() {
      var canvas = this.canvas;
      var selection = new __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__["a" /* default */].ActiveSelection(canvas.getObjects(), {
        canvas: canvas,
        hasControls: false,
        hasBorders: false
      });
      canvas.setActiveObject(selection);
      return selection;
    },
    transform: function transform() {
      var canvas = this.canvas;
      var selection = this.makeActiveSelection();
      selection.left = this.left;
      selection.top = this.top;

      var currentT = selection.calcTransformMatrix();
      var mT = __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__["a" /* default */].util.multiplyTransformMatrices(currentT, this.matrix);
      var options = __WEBPACK_IMPORTED_MODULE_0__vendor_fabric__["a" /* default */].util.qrDecompose(mT);

      selection.transformMatrix = [1, 0, 0, 1, 0, 0];
      selection.flipX = false;
      selection.flipY = false;
      selection.set(options);
      selection.setPositionByOrigin({ x: options.translateX, y: options.translateY }, 'center', 'center');
      canvas.discardActiveObject();
    },
    showSelectProductPath: function showSelectProductPath() {
      var _this4 = this;

      var canvas = this.canvas;
      var product = this.selectedProduct;
      canvas.getObjects().forEach(function (path) {
        if (path.type !== 'path') {
          return;
        }
        if (product) {
          if (product.number === path.data.product.number) {
            path.set('visible', true);
            path.set('fill', _this4.color.active.fill);
            path.set('stroke', _this4.color.active.stroke);
            path.set('strokeWidth', _this4.color.active.strokeWidth);
          } else {
            path.set('visible', false);
          }
        } else {
          path.set('visible', true);
          path.set('fill', _this4.color.default.fill);
          path.set('stroke', _this4.color.default.stroke);
          path.set('strokeWidth', _this4.color.default.strokeWidth);
        }
      });
    },
    onProductNumberChange: function onProductNumberChange() {
      this.showSelectProductPath();
      this.canvas.renderAll();
    },
    onChangeColor: function onChangeColor() {
      var _this5 = this;

      if (this.selectedProduct) {
        this.onProductNumberChange(this.selectedProduct);
      } else {
        var canvas = this.canvas;
        canvas.getObjects().forEach(function (path) {
          path.set('fill', _this5.color.default.fill);
          path.set('stroke', _this5.color.default.stroke);
          path.set('strokeWidth', _this5.color.default.strokeWidth);
        });
        this.canvas.renderAll();
      }
    },
    onFeedbackException: function onFeedbackException() {
      var _this6 = this;

      this.$confirm('确认反馈图片识别异常吗？', '提示', { type: 'warning' }).then(function () {
        _this6.feedbackExceptionloading = true;
        request.common('feedbackImageRecognitionException', { id: _this6.data.image_id }).then(function () {
          _this6.data.is_exception = 1;
        }).finally(function () {
          _this6.feedbackExceptionloading = false;
        });
      });
    }
  }
});

/***/ }),

/***/ 1580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__drawArrow__ = __webpack_require__(1725);

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DrawOverlayCanvas',
  props: {
    visible: Boolean,
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    tool: {
      type: String,
      default: 'select' // select | rect | ellipse | free | text | arrow
    },
    stroke: {
      type: String,
      default: '#ff0000'
    },
    strokeWidth: {
      type: Number,
      default: 3
    },
    rotation: {
      type: Number,
      default: 0
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    }
  },
  data: function data() {
    return {
      canvas: null,
      isPointerDown: false,
      startPoint: null,
      currentObject: null,
      hasChanges: false,
      textEditing: false,
      freeBrush: null,
      history: [],
      historyIndex: -1,
      isApplyingHistory: false,
      freeStrokeTimer: null,
      originalGetPointer: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.ensureCanvas();
        this.resize();
        this.applyTool();
      } else {
        // 不主动清空，退出画图模式时由外部调用 reset/discard
        if (this.canvas) {
          this.canvas.isDrawingMode = false;
        }
      }
    },
    width: function width() {
      this.resize();
    },
    height: function height() {
      this.resize();
    },
    rotation: function rotation() {
      var _this = this;

      // 外层 CSS 旋转后，重新计算 canvas 偏移，保证指针映射正确
      this.$nextTick(function () {
        if (_this.canvas && _this.canvas.calcOffset) {
          _this.canvas.calcOffset();
        }
      });
    },
    tool: function tool() {
      this.textEditing = false;
      this.applyTool();
    },
    stroke: function stroke() {
      this.applyTool();
    },
    strokeWidth: function strokeWidth() {
      this.applyTool();
    }
  },
  mounted: function mounted() {
    this.ensureCanvas();
    this.resize();
    this.applyTool();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.canvas) {
      this.canvas.off('keydown', this.onCanvasKeydown);
      if (this.originalGetPointer) {
        this.canvas.getPointer = this.originalGetPointer;
        this.originalGetPointer = null;
      }
      this.canvas.dispose && this.canvas.dispose();
    }
    this.canvas = null;
  },

  methods: {
    ensureCanvas: function ensureCanvas() {
      var _this2 = this;

      if (this.canvas) return;
      this.canvas = new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].Canvas(this.$refs.drawCanvas, {
        selection: true,
        preserveObjectStacking: true
      });

      // 画笔默认只在 free 模式启用
      this.freeBrush = new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].PencilBrush(this.canvas);
      this.freeBrush.color = this.stroke;
      this.freeBrush.width = this.strokeWidth;

      // 外层标注容器会 CSS 缩放/旋转，覆盖 getPointer 做逆变换
      this.originalGetPointer = this.canvas.getPointer.bind(this.canvas);
      this.canvas.getPointer = function (e, ignoreZoom) {
        return _this2.getRotatedPointer(e, ignoreZoom);
      };

      this.canvas.on('mouse:down', this.onMouseDown);
      this.canvas.on('mouse:move', this.onMouseMove);
      this.canvas.on('mouse:up', this.onMouseUp);
      this.canvas.on('keydown', this.onCanvasKeydown);

      // 兼容不同 fabric 版本的事件命名
      this.canvas.on('path:created', function () {
        _this2.hasChanges = true;
        _this2.pushHistory('free');
      });
    },
    normalizeRotation: function normalizeRotation(degree) {
      return ((Number(degree) || 0) % 360 + 360) % 360;
    },


    /**
     * 外层 CSS scale/rotate 后，将 client 坐标映射回 fabric 内部坐标系
     */
    getRotatedPointer: function getRotatedPointer(e, ignoreZoom) {
      if (!this.canvas) {
        return this.originalGetPointer ? this.originalGetPointer(e, ignoreZoom) : { x: 0, y: 0 };
      }

      var evt = e.e || e;
      var clientX = evt.touches && evt.touches[0] ? evt.touches[0].clientX : evt.clientX;
      var clientY = evt.touches && evt.touches[0] ? evt.touches[0].clientY : evt.clientY;
      if (typeof clientX !== 'number' || typeof clientY !== 'number') {
        return this.originalGetPointer(e, ignoreZoom);
      }

      var el = this.canvas.upperCanvasEl || this.$refs.drawCanvas;
      var rect = el.getBoundingClientRect();
      var canvasWidth = this.canvas.getWidth ? this.canvas.getWidth() : this.width;
      var canvasHeight = this.canvas.getHeight ? this.canvas.getHeight() : this.height;
      if (!canvasWidth || !canvasHeight) {
        return this.originalGetPointer(e, ignoreZoom);
      }

      var rotation = this.normalizeRotation(this.rotation);
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;
      var dx = clientX - centerX;
      var dy = clientY - centerY;
      // CSS rotate 为顺时针，这里做逆变换还原到元素本地坐标
      var rad = -rotation * Math.PI / 180;
      var cos = Math.cos(rad);
      var sin = Math.sin(rad);
      var localX = dx * cos - dy * sin;
      var localY = dx * sin + dy * cos;

      // 未旋转时的 CSS 显示尺寸（offset*），映射到 fabric 内部像素
      var displayWidth = el.offsetWidth || this.width || canvasWidth;
      var displayHeight = el.offsetHeight || this.height || canvasHeight;
      if (!displayWidth || !displayHeight) {
        return this.originalGetPointer(e, ignoreZoom);
      }

      return {
        x: localX * (canvasWidth / displayWidth) + canvasWidth / 2,
        y: localY * (canvasHeight / displayHeight) + canvasHeight / 2
      };
    },
    onCanvasKeydown: function onCanvasKeydown(opt) {
      if (!this.textEditing) return;
      var obj = this.canvas.getActiveObject();
      if (!obj || typeof obj.get !== 'function') return;
      var text = obj.get('text');
      if (text !== '请输入文字') return;
      var e = opt.e;
      if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        obj.set('text', e.key);
        e.preventDefault();
        e.stopPropagation();
        this.canvas.requestRenderAll();
      } else if (e.key === 'Backspace' || e.key === 'Delete') {
        obj.set('text', '');
        e.preventDefault();
        e.stopPropagation();
        this.canvas.requestRenderAll();
      }
    },
    resize: function resize() {
      if (!this.canvas) return;
      var w = Number(this.width) || 0;
      var h = Number(this.height) || 0;
      var oldW = this.canvas.getWidth ? this.canvas.getWidth() : 0;
      var oldH = this.canvas.getHeight ? this.canvas.getHeight() : 0;
      // 尺寸锁定后不再改内部坐标系，避免旋转适配时重绘对象
      if (w === oldW && h === oldH) {
        this.canvas.requestRenderAll();
        return;
      }
      if (!w || !h) return;

      this.canvas.setWidth(w);
      this.canvas.setHeight(h);
      this.canvas.setBackgroundColor(this.backgroundColor, this.canvas.renderAll.bind(this.canvas));
      this.canvas.requestRenderAll();
    },
    reset: function reset() {
      var _this3 = this;

      this.hasChanges = false;
      if (!this.canvas) return;
      this.canvas.getObjects().forEach(function (obj) {
        return _this3.canvas.remove(obj);
      });
      this.canvas.discardActiveObject && this.canvas.discardActiveObject();
      this.initHistory();
      this.pushHistory('reset', true);
      this.canvas.requestRenderAll();
    },
    discardChanges: function discardChanges() {
      this.reset();
    },
    hasDrawn: function hasDrawn() {
      return this.hasChanges;
    },
    isTextEditing: function isTextEditing() {
      return this.textEditing;
    },
    applyTool: function applyTool() {
      if (!this.canvas) return;
      if (!this.visible) return;

      // 切模式时先停掉文本编辑状态
      if (this.textEditing && this.canvas.getActiveObject && this.canvas.getActiveObject()) {
        try {
          this.canvas.getActiveObject().exitEditing && this.canvas.getActiveObject().exitEditing();
        } catch (e) {
          // ignore
        }
      }
      this.textEditing = false;

      var tool = this.tool;
      var isSelect = tool === 'select';

      if (tool === 'free') {
        this.canvas.isDrawingMode = true;
        this.freeBrush.color = this.stroke;
        this.freeBrush.width = this.strokeWidth;
        this.canvas.freeDrawingBrush = this.freeBrush;
        this.canvas.selection = false;
        return;
      }

      this.canvas.isDrawingMode = false;
      this.canvas.selection = isSelect;

      // 工具状态下的对象可交互性：仅 select 时可选中/拖动
      this.canvas.getObjects().forEach(function (obj) {
        obj.selectable = isSelect;
        obj.evented = isSelect;
        obj.hasControls = false;
        obj.hasBorders = false;
        obj.lockRotation = true;
        obj.lockScalingX = true;
        obj.lockScalingY = true;
      });

      this.canvas.requestRenderAll();
    },
    emitHistoryChange: function emitHistoryChange() {
      var canUndo = this.historyIndex > 0;
      var canRedo = this.historyIndex >= 0 && this.historyIndex < this.history.length - 1;
      this.$emit && this.$emit('history-change', { canUndo: canUndo, canRedo: canRedo });
    },
    initHistory: function initHistory() {
      this.history = [];
      this.historyIndex = -1;
    },
    getCanvasState: function getCanvasState() {
      // 仅保存当前对象层；不保存透明背景色也没关系
      return this.canvas.toJSON();
    },
    pushHistory: function pushHistory(reason) {
      var _this4 = this;

      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!this.canvas) return;
      if (this.isApplyingHistory && !force) return;

      // freeDrawing 可能在一次 stroke 内多次触发，做个轻量 debounce
      if (reason === 'free') {
        clearTimeout(this.freeStrokeTimer);
        this.freeStrokeTimer = setTimeout(function () {
          _this4.pushHistory('free-inner', force);
        }, 120);
        return;
      }

      // 若撤销过，再继续操作需要截断 redo 分支
      if (this.historyIndex < this.history.length - 1) {
        this.history = this.history.slice(0, this.historyIndex + 1);
      }

      var state = this.getCanvasState();
      this.history.push(state);
      this.historyIndex++;
      this.updateHasChangesByObjects();
      this.emitHistoryChange();
    },
    updateHasChangesByObjects: function updateHasChangesByObjects() {
      if (!this.canvas) {
        this.hasChanges = false;
        return;
      }
      var objects = this.canvas.getObjects ? this.canvas.getObjects() : [];
      this.hasChanges = !!(objects && objects.length);
    },
    applyCanvasState: function applyCanvasState(json) {
      var _this5 = this;

      if (!this.canvas) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();

      this.isApplyingHistory = true;
      this.canvas.clear();
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this5.canvas.loadFromJSON(json, function () {
          _this5.isApplyingHistory = false;
          _this5.updateHasChangesByObjects();
          // clear() 会移除背景色，undo/redo 后需要重新设置
          _this5.canvas.setBackgroundColor(_this5.backgroundColor, _this5.canvas.renderAll.bind(_this5.canvas));
          _this5.canvas.requestRenderAll();
          _this5.emitHistoryChange();
          resolve();
        });
      });
    },
    undo: function undo() {
      if (!this.canUndo()) return;
      this.historyIndex--;
      return this.applyCanvasState(this.history[this.historyIndex]);
    },
    redo: function redo() {
      if (!this.canRedo()) return;
      this.historyIndex++;
      return this.applyCanvasState(this.history[this.historyIndex]);
    },
    canUndo: function canUndo() {
      return this.historyIndex > 0;
    },
    canRedo: function canRedo() {
      return this.historyIndex >= 0 && this.historyIndex < this.history.length - 1;
    },
    getPointerInCanvas: function getPointerInCanvas(opt) {
      var pointer = this.canvas.getPointer(opt.e);
      return { x: pointer.x, y: pointer.y };
    },
    onMouseDown: function onMouseDown(opt) {
      var _this6 = this;

      if (!this.visible) return;
      if (this.tool === 'free') return;
      if (this.textEditing) return;

      var tool = this.tool;
      if (tool === 'select') return;

      this.isPointerDown = true;
      this.startPoint = this.getPointerInCanvas(opt);

      if (tool === 'rect') {
        this.currentObject = new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].Rect({
          left: this.startPoint.x,
          top: this.startPoint.y,
          width: 0,
          height: 0,
          fill: 'rgba(0,0,0,0)',
          stroke: this.stroke,
          strokeWidth: this.strokeWidth,
          selectable: false,
          evented: false,
          hasControls: false,
          hasBorders: false,
          lockRotation: true,
          lockScalingX: true,
          lockScalingY: true
        });
        this.canvas.add(this.currentObject);
      } else if (tool === 'arrow') {
        var endPoint = {
          x: this.startPoint.x,
          y: this.startPoint.y
        };
        var line = new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].Line([this.startPoint.x, this.startPoint.y, endPoint.x, endPoint.y], {
          fill: this.stroke,
          stroke: this.stroke,
          strokeWidth: this.strokeWidth,
          selectable: false,
          evented: false,
          hasControls: false,
          hasBorders: false,
          lockRotation: true,
          lockScalingX: true,
          lockScalingY: true
        });
        var headSegments = Object(__WEBPACK_IMPORTED_MODULE_2__drawArrow__["a" /* createArrowHeadSegments */])(this.startPoint, endPoint);
        var headLines = headSegments.map(function (segment) {
          return new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].Line([segment[0].x, segment[0].y, segment[1].x, segment[1].y], {
            fill: _this6.stroke,
            stroke: _this6.stroke,
            strokeWidth: _this6.strokeWidth,
            selectable: false,
            evented: false,
            hasControls: false,
            hasBorders: false,
            lockRotation: true,
            lockScalingX: true,
            lockScalingY: true
          });
        });
        this.currentObject = { line: line, headLines: headLines };
        this.canvas.add(line);
        headLines.forEach(function (headLine) {
          return _this6.canvas.add(headLine);
        });
      } else if (tool === 'ellipse') {
        this.currentObject = new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].Ellipse({
          left: this.startPoint.x,
          top: this.startPoint.y,
          originX: 'left',
          originY: 'top',
          rx: 0,
          ry: 0,
          fill: 'rgba(0,0,0,0)',
          stroke: this.stroke,
          strokeWidth: this.strokeWidth,
          selectable: false,
          evented: false,
          hasControls: false,
          hasBorders: false,
          lockRotation: true
        });
        this.canvas.add(this.currentObject);
      } else if (tool === 'circle') {
        // 兼容旧调用；circle 行为等价于 shift 绘制圆形
        this.currentObject = new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].Ellipse({
          left: this.startPoint.x,
          top: this.startPoint.y,
          originX: 'left',
          originY: 'top',
          rx: 0,
          ry: 0,
          fill: 'rgba(0,0,0,0)',
          stroke: this.stroke,
          strokeWidth: this.strokeWidth,
          selectable: false,
          evented: false,
          hasControls: false,
          hasBorders: false,
          lockRotation: true
        });
        this.canvas.add(this.currentObject);
      } else if (tool === 'text') {
        var textbox = new __WEBPACK_IMPORTED_MODULE_1__vendor_fabric__["a" /* default */].Textbox('', {
          left: this.startPoint.x,
          top: this.startPoint.y,
          fontSize: 20,
          fill: this.stroke,
          originX: 'left',
          originY: 'top'
        });
        this.canvas.add(textbox);
        this.canvas.setActiveObject(textbox);
        this.hasChanges = true;
        this.textEditing = true;
        textbox.enterEditing && textbox.enterEditing();
        textbox.on('editing:exited', function () {
          _this6.textEditing = false;
          _this6.pushHistory('text');
          _this6.applyTool();
        });
        textbox.on('modified', function () {
          _this6.hasChanges = true;
        });
      }

      this.canvas.requestRenderAll();
    },
    onMouseMove: function onMouseMove(opt) {
      if (!this.visible) return;
      if (!this.isPointerDown) return;
      if (!this.currentObject) return;
      var tool = this.tool;
      if (!['rect', 'circle', 'ellipse', 'arrow'].includes(tool)) return;

      var p = this.getPointerInCanvas(opt);
      var x1 = this.startPoint.x;
      var y1 = this.startPoint.y;
      var x2 = p.x;
      var y2 = p.y;
      var left = Math.min(x1, x2);
      var top = Math.min(y1, y2);
      var w = Math.abs(x2 - x1);
      var h = Math.abs(y2 - y1);

      if (tool === 'rect') {
        this.currentObject.set({
          left: left,
          top: top,
          width: w,
          height: h
        });
      } else if (tool === 'ellipse') {
        // ellipse + shift => circle
        if (opt && opt.e && opt.e.shiftKey) {
          var d = Math.max(w, h);
          this.currentObject.set({
            left: left,
            top: top,
            rx: d / 2,
            ry: d / 2
          });
        } else {
          this.currentObject.set({
            left: left,
            top: top,
            rx: w / 2,
            ry: h / 2
          });
        }
      } else if (tool === 'circle') {
        var _d = Math.max(w, h);
        this.currentObject.set({
          left: left,
          top: top,
          rx: _d / 2,
          ry: _d / 2
        });
      } else if (tool === 'arrow') {
        this.currentObject.line.set({
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2
        });
        var headSegments = Object(__WEBPACK_IMPORTED_MODULE_2__drawArrow__["a" /* createArrowHeadSegments */])(this.startPoint, p);
        this.currentObject.headLines.forEach(function (headLine, index) {
          var segment = headSegments[index];
          headLine.set({
            x1: segment[0].x,
            y1: segment[0].y,
            x2: segment[1].x,
            y2: segment[1].y
          });
          headLine.setCoords && headLine.setCoords();
        });
        this.currentObject.line.setCoords && this.currentObject.line.setCoords();
      }

      this.canvas.requestRenderAll();
    },
    onMouseUp: function onMouseUp() {
      if (!this.visible) return;
      if (this.tool === 'free') return;
      if (!this.isPointerDown) return;

      this.isPointerDown = false;
      if (this.currentObject) {
        this.hasChanges = true;
        if (this.tool === 'arrow') {
          this.currentObject.line.set({
            selectable: false,
            evented: false
          });
          this.currentObject.headLines.forEach(function (headLine) {
            return headLine.set({
              selectable: false,
              evented: false
            });
          });
        } else {
          this.currentObject.set({
            selectable: false,
            evented: false
          });
        }
        this.pushHistory('shape');
      }

      this.currentObject = null;
      this.startPoint = null;
      this.canvas.requestRenderAll();
    },
    getOverlayDataUrl: function getOverlayDataUrl() {
      if (!this.canvas) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('');
      // 透明背景下用 png，避免颜色丢失
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.canvas.toDataURL({ format: 'png' }));
    }
  }
});

/***/ }),

/***/ 1581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DrawToolbar',
  props: {
    stroke: {
      type: String,
      default: '#409eff'
    },
    drawSaving: {
      type: Boolean,
      default: false
    },
    drawCanUndo: {
      type: Boolean,
      default: false
    },
    drawCanRedo: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localStroke: this.stroke,
      predefineColors: ['#409eff', '#67c23a', '#e6a23c', '#f56c6c', '#909399']
    };
  },

  watch: {
    stroke: function stroke(val) {
      this.localStroke = val;
    }
  },
  methods: {
    onStrokeChange: function onStrokeChange(val) {
      this.$emit('stroke-change', val);
    }
  }
});

/***/ }),

/***/ 1621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewImage_vue__ = __webpack_require__(1578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e86d2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewImage_vue__ = __webpack_require__(1731);
function injectStyle (ssrContext) {
  __webpack_require__(1711)
  this["$style"] = __webpack_require__(1713)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79e86d2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e86d2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1711:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1712);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("34028b05", content, true, {});

/***/ }),

/***/ 1712:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".view-content[data-v-79e86d2e]{height:calc(100% - 57px);overflow:hidden;position:relative}.view-toolbar[data-v-79e86d2e]{left:16px;bottom:76px;max-height:calc(100% - 146px);overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;position:absolute;top:70px;text-align:left;z-index:40}.view-toolbar ul[data-v-79e86d2e]{display:block;list-style:none;margin:0;overflow:visible;padding:0}.view-toolbar ul li[data-v-79e86d2e]{margin:0 0 8px;background-color:rgba(0,0,0,.5);border-radius:50%;cursor:pointer;display:block;height:48px;overflow:hidden;-webkit-transition:background-color .15s;transition:background-color .15s;text-align:center;width:48px}.view-toolbar ul li[data-v-79e86d2e]:hover{background-color:rgba(0,0,0,.8)}.view-toolbar ul li [class*=\" el-icon-\"][data-v-79e86d2e],.view-toolbar ul li [class*=\" sj-icon-\"][data-v-79e86d2e],.view-toolbar ul li [class^=el-icon-][data-v-79e86d2e],.view-toolbar ul li [class^=sj-icon-][data-v-79e86d2e]{color:hsla(0,0%,100%,.7);font-size:24px;line-height:48px}.view-toolbar ul li .draw-entry-text[data-v-79e86d2e]{color:#409eff;display:block;font-size:13px;font-weight:700;line-height:16px}.view-toolbar ul li.draw-entry[data-v-79e86d2e]{background-color:#ecf5ff;border:1px solid #b3d8ff;border-radius:8px;-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;min-height:48px;padding:6px 4px;width:48px}.view-toolbar ul li.draw-entry[data-v-79e86d2e]:hover{background-color:#d9ecff;border-color:#409eff}.view-toolbar-bottom[data-v-79e86d2e]{bottom:57px;left:0;overflow:hidden;position:absolute;right:0;text-align:center;height:36px;z-index:40}.view-toolbar-bottom ul[data-v-79e86d2e]{display:inline-block;margin:0 auto 5px;overflow:hidden;padding:3px 0}.view-toolbar-bottom ul li[data-v-79e86d2e]{margin:0 1px;background-color:rgba(0,0,0,.5);border-radius:50%;cursor:pointer;float:left;height:24px;overflow:hidden;-webkit-transition:background-color .15s;transition:background-color .15s;width:24px}.view-toolbar-bottom ul li[data-v-79e86d2e]:hover{background-color:rgba(0,0,0,.8)}.view-toolbar-bottom ul li [class*=\" el-icon-\"][data-v-79e86d2e],.view-toolbar-bottom ul li [class*=\" sj-icon-\"][data-v-79e86d2e],.view-toolbar-bottom ul li [class^=el-icon-][data-v-79e86d2e],.view-toolbar-bottom ul li [class^=sj-icon-][data-v-79e86d2e]{color:hsla(0,0%,100%,.7);line-height:24px}.draw-disabled[data-v-79e86d2e]{cursor:not-allowed!important;opacity:.5}.draw-overlay-wrap[data-v-79e86d2e]{z-index:20;overflow:hidden}.draw-overlay-wrap[data-v-79e86d2e] .canvas-container,.draw-overlay-wrap[data-v-79e86d2e] .canvas-container canvas{width:100%!important;height:100%!important}.draw-toolbar[data-v-79e86d2e]{bottom:57px;left:0;right:0;position:absolute;overflow:hidden;text-align:center;z-index:30;pointer-events:auto}.draw-toolbar ul[data-v-79e86d2e]{list-style:none;padding:0;margin:0 auto;display:inline-block;background-color:rgba(0,0,0,.55);border-radius:6px}.draw-toolbar li[data-v-79e86d2e]{display:inline-block;padding:0 6px}.draw-toolbar .draw-toolbar-actions[data-v-79e86d2e]{padding-left:10px}.draw-toolbar .el-button[data-v-79e86d2e]{color:hsla(0,0%,100%,.75)}.draw-toolbar .paint-icon[data-v-79e86d2e]{width:14px;height:14px;vertical-align:middle;color:currentColor}.draw-toolbar .paint-icon ellipse[data-v-79e86d2e],.draw-toolbar .paint-icon path[data-v-79e86d2e],.draw-toolbar .paint-icon rect[data-v-79e86d2e]{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.draw-toolbar .el-button.is-disabled .paint-icon[data-v-79e86d2e]{opacity:.35}.view-navbar[data-v-79e86d2e]{position:absolute;right:0;bottom:0;width:100%;background-color:rgba(0,0,0,.95);overflow:hidden;z-index:25}.view-navbar ul[data-v-79e86d2e]{-webkit-transform:translateX(0);transform:translateX(0);margin:10px 0;-webkit-transition:all .3s;transition:all .3s;-webkit-box-sizing:content-box;box-sizing:content-box;height:55px;margin:0;overflow:hidden;padding:1px 0}.view-navbar ul li[data-v-79e86d2e]{list-style:none;width:55px;height:55px;margin-right:5px;background-color:#fff;color:transparent;cursor:pointer;float:left;font-size:0;line-height:0;opacity:.5;overflow:hidden;-webkit-transition:opacity .15s;transition:opacity .15s}.view-navbar ul li.active[data-v-79e86d2e]{opacity:1}.view-footer-badge[data-v-79e86d2e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;right:0;bottom:60px;height:75px;width:100px;position:absolute;border-radius:50% 0 0 50%;background:hsla(220,4%,58%,.3);font-size:30px}.view-footer-badge div[data-v-79e86d2e]{line-height:75px;color:#fff}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/AnswerFileFullScreen/src/ViewImage.vue"],"names":[],"mappings":"AACA,+BAA+B,yBAAyB,gBAAgB,iBAAiB,CACxF,AACD,+BAA+B,UAAU,YAAY,8BAA8B,kBAAkB,gBAAgB,4BAA4B,kBAAkB,SAAS,gBAAgB,UAAU,CACrM,AACD,kCAAkC,cAAc,gBAAgB,SAAS,iBAAiB,SAAS,CAClG,AACD,qCAAqC,eAAe,gCAAiC,kBAAkB,eAAe,cAAc,YAAY,gBAAgB,yCAA0C,iCAAkC,kBAAkB,UAAU,CACvQ,AACD,2CAA2C,+BAAgC,CAC1E,AACD,kOAAsO,yBAA4B,eAAe,gBAAgB,CAChS,AACD,sDAAsD,cAAc,cAAc,eAAe,gBAAiB,gBAAgB,CACjI,AACD,gDAAgD,yBAAyB,yBAAyB,kBAAkB,8BAA8B,sBAAsB,YAAY,gBAAgB,gBAAgB,UAAU,CAC7N,AACD,sDAAsD,yBAAyB,oBAAoB,CAClG,AACD,sCAAsC,YAAY,OAAO,gBAAgB,kBAAkB,QAAQ,kBAAkB,YAAY,UAAU,CAC1I,AACD,yCAAyC,qBAAqB,kBAAkB,gBAAgB,aAAa,CAC5G,AACD,4CAA4C,aAAe,gCAAiC,kBAAkB,eAAe,WAAW,YAAY,gBAAgB,yCAA0C,iCAAkC,UAAU,CACzP,AACD,kDAAkD,+BAAgC,CACjF,AACD,8PAAkQ,yBAA4B,gBAAgB,CAC7S,AACD,gCAAgC,6BAA8B,UAAW,CACxE,AACD,oCAAoC,WAAW,eAAe,CAC7D,AAGD,mHAA6D,qBAAsB,qBAAsB,CACxG,AACD,+BAA+B,YAAY,OAAO,QAAQ,kBAAkB,gBAAgB,kBAAkB,WAAW,mBAAmB,CAC3I,AACD,kCAAkC,gBAAgB,UAAU,cAAc,qBAAqB,iCAAkC,iBAAiB,CACjJ,AACD,kCAAkC,qBAAqB,aAAa,CACnE,AACD,qDAAqD,iBAAiB,CACrE,AACD,0CAA0C,yBAA4B,CACrE,AACD,2CAA2C,WAAW,YAAY,sBAAsB,kBAAkB,CACzG,AACD,mJAAmJ,UAAU,oBAAoB,eAAe,qBAAqB,qBAAqB,CACzO,AACD,kEAAkE,WAAY,CAC7E,AACD,8BAA8B,kBAAkB,QAAU,SAAW,WAAW,iCAAkC,gBAAgB,UAAU,CAC3I,AACD,iCAAiC,gCAAkC,wBAA0B,cAAgB,2BAA4B,mBAAoB,+BAA+B,uBAAuB,YAAY,SAAS,gBAAgB,aAAa,CACpQ,AACD,oCAA+C,gBAAgB,WAAW,YAAY,iBAAiB,sBAAsB,kBAAkB,eAAe,WAAW,YAAY,cAAc,WAAY,gBAAgB,gCAAiC,uBAAwB,CACvR,AACD,2CAA2C,SAAS,CACnD,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAU,YAAY,YAAY,YAAY,kBAAkB,0BAA0B,+BAAiC,cAAc,CACrS,AACD,wCAAwC,iBAAiB,UAAU,CAClE","file":"ViewImage.vue","sourcesContent":["\n.view-content[data-v-79e86d2e]{height:calc(100% - 57px);overflow:hidden;position:relative\n}\n.view-toolbar[data-v-79e86d2e]{left:16px;bottom:76px;max-height:calc(100% - 146px);overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;position:absolute;top:70px;text-align:left;z-index:40\n}\n.view-toolbar ul[data-v-79e86d2e]{display:block;list-style:none;margin:0;overflow:visible;padding:0\n}\n.view-toolbar ul li[data-v-79e86d2e]{margin:0 0 8px;background-color:rgba(0,0,0,0.5);border-radius:50%;cursor:pointer;display:block;height:48px;overflow:hidden;-webkit-transition:background-color 0.15s;transition:background-color 0.15s;text-align:center;width:48px\n}\n.view-toolbar ul li[data-v-79e86d2e]:hover{background-color:rgba(0,0,0,0.8)\n}\n.view-toolbar ul li [class*=\" el-icon-\"][data-v-79e86d2e],.view-toolbar ul li [class^=\"el-icon-\"][data-v-79e86d2e],.view-toolbar ul li [class*=\" sj-icon-\"][data-v-79e86d2e],.view-toolbar ul li [class^=\"sj-icon-\"][data-v-79e86d2e]{color:rgba(255,255,255,0.7);font-size:24px;line-height:48px\n}\n.view-toolbar ul li .draw-entry-text[data-v-79e86d2e]{color:#409EFF;display:block;font-size:13px;font-weight:bold;line-height:16px\n}\n.view-toolbar ul li.draw-entry[data-v-79e86d2e]{background-color:#ecf5ff;border:1px solid #b3d8ff;border-radius:8px;-webkit-box-sizing:border-box;box-sizing:border-box;height:auto;min-height:48px;padding:6px 4px;width:48px\n}\n.view-toolbar ul li.draw-entry[data-v-79e86d2e]:hover{background-color:#d9ecff;border-color:#409EFF\n}\n.view-toolbar-bottom[data-v-79e86d2e]{bottom:57px;left:0;overflow:hidden;position:absolute;right:0;text-align:center;height:36px;z-index:40\n}\n.view-toolbar-bottom ul[data-v-79e86d2e]{display:inline-block;margin:0 auto 5px;overflow:hidden;padding:3px 0\n}\n.view-toolbar-bottom ul li[data-v-79e86d2e]{margin:0px 1px;background-color:rgba(0,0,0,0.5);border-radius:50%;cursor:pointer;float:left;height:24px;overflow:hidden;-webkit-transition:background-color 0.15s;transition:background-color 0.15s;width:24px\n}\n.view-toolbar-bottom ul li[data-v-79e86d2e]:hover{background-color:rgba(0,0,0,0.8)\n}\n.view-toolbar-bottom ul li [class*=\" el-icon-\"][data-v-79e86d2e],.view-toolbar-bottom ul li [class^=\"el-icon-\"][data-v-79e86d2e],.view-toolbar-bottom ul li [class*=\" sj-icon-\"][data-v-79e86d2e],.view-toolbar-bottom ul li [class^=\"sj-icon-\"][data-v-79e86d2e]{color:rgba(255,255,255,0.7);line-height:24px\n}\n.draw-disabled[data-v-79e86d2e]{cursor:not-allowed !important;opacity:0.5\n}\n.draw-overlay-wrap[data-v-79e86d2e]{z-index:20;overflow:hidden\n}\n.draw-overlay-wrap[data-v-79e86d2e] .canvas-container{width:100% !important;height:100% !important\n}\n.draw-overlay-wrap[data-v-79e86d2e] .canvas-container canvas{width:100% !important;height:100% !important\n}\n.draw-toolbar[data-v-79e86d2e]{bottom:57px;left:0;right:0;position:absolute;overflow:hidden;text-align:center;z-index:30;pointer-events:auto\n}\n.draw-toolbar ul[data-v-79e86d2e]{list-style:none;padding:0;margin:0 auto;display:inline-block;background-color:rgba(0,0,0,0.55);border-radius:6px\n}\n.draw-toolbar li[data-v-79e86d2e]{display:inline-block;padding:0 6px\n}\n.draw-toolbar .draw-toolbar-actions[data-v-79e86d2e]{padding-left:10px\n}\n.draw-toolbar .el-button[data-v-79e86d2e]{color:rgba(255,255,255,0.75)\n}\n.draw-toolbar .paint-icon[data-v-79e86d2e]{width:14px;height:14px;vertical-align:middle;color:currentColor\n}\n.draw-toolbar .paint-icon path[data-v-79e86d2e],.draw-toolbar .paint-icon rect[data-v-79e86d2e],.draw-toolbar .paint-icon ellipse[data-v-79e86d2e]{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round\n}\n.draw-toolbar .el-button.is-disabled .paint-icon[data-v-79e86d2e]{opacity:0.35\n}\n.view-navbar[data-v-79e86d2e]{position:absolute;right:0px;bottom:0px;width:100%;background-color:rgba(0,0,0,0.95);overflow:hidden;z-index:25\n}\n.view-navbar ul[data-v-79e86d2e]{-webkit-transform:translateX(0px);transform:translateX(0px);margin:10px 0px;-webkit-transition:all 0.3s;transition:all 0.3s;-webkit-box-sizing:content-box;box-sizing:content-box;height:55px;margin:0;overflow:hidden;padding:1px 0\n}\n.view-navbar ul li[data-v-79e86d2e]{float:left;list-style:none;width:55px;height:55px;margin-right:5px;background-color:#fff;color:transparent;cursor:pointer;float:left;font-size:0;line-height:0;opacity:0.5;overflow:hidden;-webkit-transition:opacity 0.15s;transition:opacity 0.15s\n}\n.view-navbar ul li.active[data-v-79e86d2e]{opacity:1\n}\n.view-footer-badge[data-v-79e86d2e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;right:0px;bottom:60px;height:75px;width:100px;position:absolute;border-radius:50% 0 0 50%;background:rgba(144,147,153,0.3);font-size:30px\n}\n.view-footer-badge div[data-v-79e86d2e]{line-height:75px;color:#fff\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("77ea3186", content, true, {});

/***/ }),

/***/ 1714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ViewImage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1715:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol__);







/*!
 * Viewer.js v1.2.0
 * https://fengyuanchen.github.io/viewerjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2018-07-15T10:10:54.376Z
 */

var DEFAULTS = {
  /**
   * Define the initial index of image for viewing.
   * @type {number}
   */
  initialViewIndex: 0,

  /**
   * Enable inline mode.
   * @type {boolean}
   */
  inline: false,

  /**
   * Show the button on the top-right of the viewer.
   * @type {boolean}
   */
  button: true,

  /**
   * Show the navbar.
   * @type {boolean | number}
   */
  navbar: true,

  /**
   * Specify the visibility and the content of the title.
   * @type {boolean | number | Function | Array}
   */
  title: true,

  /**
   * Show the toolbar.
   * @type {boolean | number | Object}
   */
  toolbar: true,

  /**
   * Show the tooltip with image ratio (percentage) when zoom in or zoom out.
   * @type {boolean}
   */
  tooltip: true,

  /**
   * Enable to move the image.
   * @type {boolean}
   */
  movable: true,

  /**
   * Enable to zoom the image.
   * @type {boolean}
   */
  zoomable: true,

  /**
   * Enable to rotate the image.
   * @type {boolean}
   */
  rotatable: true,

  /**
   * Enable to scale the image.
   * @type {boolean}
   */
  scalable: true,

  /**
   * Enable CSS3 Transition for some special elements.
   * @type {boolean}
   */
  transition: true,

  /**
   * Enable to request fullscreen when play.
   * @type {boolean}
   */
  fullscreen: true,

  /**
   * The amount of time to delay between automatically cycling an image when playing.
   * @type {number}
   */
  interval: 5000,

  /**
   * Enable keyboard support.
   * @type {boolean}
   */
  keyboard: true,

  /**
   * Enable a modal backdrop, specify `static` for a backdrop
   * which doesn't close the modal on click.
   * @type {boolean}
   */
  backdrop: true,

  /**
   * Indicate if show a loading spinner when load image or not.
   * @type {boolean}
   */
  loading: true,

  /**
   * Indicate if enable loop viewing or not.
   * @type {boolean}
   */
  loop: true,

  /**
   * Min width of the viewer in inline mode.
   * @type {number}
   */
  minWidth: 200,

  /**
   * Min height of the viewer in inline mode.
   * @type {number}
   */
  minHeight: 100,

  /**
   * Define the ratio when zoom the image by wheeling mouse.
   * @type {number}
   */
  zoomRatio: 0.1,

  /**
   * Define the min ratio of the image when zoom out.
   * @type {number}
   */
  minZoomRatio: 0.01,

  /**
   * Define the max ratio of the image when zoom in.
   * @type {number}
   */
  maxZoomRatio: 100,

  /**
   * Define the CSS `z-index` value of viewer in modal mode.
   * @type {number}
   */
  zIndex: 2015,

  /**
   * Define the CSS `z-index` value of viewer in inline mode.
   * @type {number}
   */
  zIndexInline: 0,

  /**
   * Define where to get the original image URL for viewing.
   * @type {string | Function}
   */
  url: 'src',

  /**
   * Define where to put the viewer in modal mode.
   * @type {string | Element}
   */
  container: 'body',

  /**
   * Filter the images for viewing. Return true if the image is viewable.
   * @type {Function}
   */
  filter: null,

  /**
   * Indicate if toggle the image size between its natural size
   * and initial size when double click on the image or not.
   * @type {boolean}
   */
  toggleOnDblclick: true,

  /**
   * Event shortcuts.
   * @type {Function}
   */
  ready: null,
  show: null,
  shown: null,
  hide: null,
  hidden: null,
  view: null,
  viewed: null,
  zoom: null,
  zoomed: null
};

var TEMPLATE = '<div class="viewer-container" touch-action="none">' + '<div class="viewer-canvas"></div>' + '<div class="viewer-footer">' + '<div class="viewer-title"></div>' + '<div class="viewer-toolbar"></div>' + '<div class="viewer-navbar">' + '<ul class="viewer-list"></ul>' + '</div>' + '</div>' + '<div class="viewer-tooltip"></div>' + '<div role="button" class="viewer-button" data-viewer-action="mix"></div>' + '<div class="viewer-player"></div>' + '</div>';

var IN_BROWSER = typeof window !== 'undefined';
var WINDOW = IN_BROWSER ? window : {};
var NAMESPACE = 'viewer';

// Actions
var ACTION_MOVE = 'move';
var ACTION_SWITCH = 'switch';
var ACTION_ZOOM = 'zoom';

// Classes
var CLASS_ACTIVE = NAMESPACE + '-active';
var CLASS_CLOSE = NAMESPACE + '-close';
var CLASS_FADE = NAMESPACE + '-fade';
var CLASS_FIXED = NAMESPACE + '-fixed';
var CLASS_FULLSCREEN = NAMESPACE + '-fullscreen';
var CLASS_FULLSCREEN_EXIT = NAMESPACE + '-fullscreen-exit';
var CLASS_HIDE = NAMESPACE + '-hide';
var CLASS_HIDE_MD_DOWN = NAMESPACE + '-hide-md-down';
var CLASS_HIDE_SM_DOWN = NAMESPACE + '-hide-sm-down';
var CLASS_HIDE_XS_DOWN = NAMESPACE + '-hide-xs-down';
var CLASS_IN = NAMESPACE + '-in';
var CLASS_INVISIBLE = NAMESPACE + '-invisible';
var CLASS_LOADING = NAMESPACE + '-loading';
var CLASS_MOVE = NAMESPACE + '-move';
var CLASS_OPEN = NAMESPACE + '-open';
var CLASS_SHOW = NAMESPACE + '-show';
var CLASS_TRANSITION = NAMESPACE + '-transition';

// Events
var EVENT_CLICK = 'click';
var EVENT_DBLCLICK = 'dblclick';
var EVENT_DRAG_START = 'dragstart';
var EVENT_HIDDEN = 'hidden';
var EVENT_HIDE = 'hide';
var EVENT_KEY_DOWN = 'keydown';
var EVENT_LOAD = 'load';
var EVENT_POINTER_DOWN = WINDOW.PointerEvent ? 'pointerdown' : 'touchstart mousedown';
var EVENT_POINTER_MOVE = WINDOW.PointerEvent ? 'pointermove' : 'touchmove mousemove';
var EVENT_POINTER_UP = WINDOW.PointerEvent ? 'pointerup pointercancel' : 'touchend touchcancel mouseup';
var EVENT_READY = 'ready';
var EVENT_RESIZE = 'resize';
var EVENT_SHOW = 'show';
var EVENT_SHOWN = 'shown';
var EVENT_TRANSITION_END = 'transitionend';
var EVENT_VIEW = 'view';
var EVENT_VIEWED = 'viewed';
var EVENT_WHEEL = 'wheel mousewheel DOMMouseScroll';
var EVENT_ZOOM = 'zoom';
var EVENT_ZOOMED = 'zoomed';

// Data keys
var DATA_ACTION = NAMESPACE + 'Action';
var BUTTONS = ['zoom-in', 'zoom-out', 'one-to-one', 'reset', 'prev', 'play', 'next', 'rotate-left', 'rotate-right', 'flip-horizontal', 'flip-vertical'];

var _typeof = typeof __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a === "function" && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_symbol_iterator___default.a) === "symbol" ? function (obj) {
  return typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj);
} : function (obj) {
  return obj && typeof __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(obj);
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/**
 * Check if the given value is a string.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a string, else `false`.
 */
function isString(value) {
  return typeof value === 'string';
}

/**
 * Check if the given value is not a number.
 */
var isNaN = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default.a || WINDOW.isNaN;

/**
 * Check if the given value is a number.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a number, else `false`.
 */
function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}

/**
 * Check if the given value is undefined.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
 */
function isUndefined(value) {
  return typeof value === 'undefined';
}

/**
 * Check if the given value is an object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is an object, else `false`.
 */
function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Check if the given value is a plain object.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
 */

function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }

  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;

    return _constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
  } catch (e) {
    return false;
  }
}

/**
 * Check if the given value is a function.
 * @param {*} value - The value to check.
 * @returns {boolean} Returns `true` if the given value is a function, else `false`.
 */
function isFunction(value) {
  return typeof value === 'function';
}

/**
 * Iterate the given data.
 * @param {*} data - The data to iterate.
 * @param {Function} callback - The process function for each element.
 * @returns {*} The original data.
 */
function forEach(data, callback) {
  if (data && isFunction(callback)) {
    if (Array.isArray(data) || isNumber(data.length) /* array-like */) {
        var length = data.length;

        var i = void 0;

        for (i = 0; i < length; i += 1) {
          if (callback.call(data, data[i], i, data) === false) {
            break;
          }
        }
      } else if (isObject(data)) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
        callback.call(data, data[key], key, data);
      });
    }
  }

  return data;
}

/**
 * Extend the given object.
 * @param {*} obj - The object to be extended.
 * @param {*} args - The rest objects which will be merged to the first object.
 * @returns {Object} The extended object.
 */
var assign = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || function assign(obj) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (isObject(obj) && args.length > 0) {
    args.forEach(function (arg) {
      if (isObject(arg)) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(arg).forEach(function (key) {
          obj[key] = arg[key];
        });
      }
    });
  }

  return obj;
};

var REGEXP_SUFFIX = /^(?:width|height|left|top|marginLeft|marginTop)$/;

/**
 * Apply styles to the given element.
 * @param {Element} element - The target element.
 * @param {Object} styles - The styles for applying.
 */
function setStyle(element, styles) {
  var style = element.style;

  forEach(styles, function (value, property) {
    if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
      value += 'px';
    }

    style[property] = value;
  });
}

/**
 * Check if the given element has a special class.
 * @param {Element} element - The element to check.
 * @param {string} value - The class to search.
 * @returns {boolean} Returns `true` if the special class was found.
 */
function hasClass(element, value) {
  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
}

/**
 * Add classes to the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be added.
 */
function addClass(element, value) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      addClass(elem, value);
    });
    return;
  }

  if (element.classList) {
    element.classList.add(value);
    return;
  }

  var className = element.className.trim();

  if (!className) {
    element.className = value;
  } else if (className.indexOf(value) < 0) {
    element.className = className + ' ' + value;
  }
}

/**
 * Remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be removed.
 */
function removeClass(element, value) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      removeClass(elem, value);
    });
    return;
  }

  if (element.classList) {
    element.classList.remove(value);
    return;
  }

  if (element.className.indexOf(value) >= 0) {
    element.className = element.className.replace(value, '');
  }
}

/**
 * Add or remove classes from the given element.
 * @param {Element} element - The target element.
 * @param {string} value - The classes to be toggled.
 * @param {boolean} added - Add only.
 */
function toggleClass(element, value, added) {
  if (!value) {
    return;
  }

  if (isNumber(element.length)) {
    forEach(element, function (elem) {
      toggleClass(elem, value, added);
    });
    return;
  }

  // IE10-11 doesn't support the second parameter of `classList.toggle`
  if (added) {
    addClass(element, value);
  } else {
    removeClass(element, value);
  }
}

var REGEXP_HYPHENATE = /([a-z\d])([A-Z])/g;

/**
 * Transform the given string from camelCase to kebab-case
 * @param {string} value - The value to transform.
 * @returns {string} The transformed value.
 */
function hyphenate(value) {
  return value.replace(REGEXP_HYPHENATE, '$1-$2').toLowerCase();
}

/**
 * Get data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to get.
 * @returns {string} The data value.
 */
function getData(element, name) {
  if (isObject(element[name])) {
    return element[name];
  }

  if (element.dataset) {
    return element.dataset[name];
  }

  return element.getAttribute('data-' + hyphenate(name));
}

/**
 * Set data to the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to set.
 * @param {string} data - The data value.
 */
function setData(element, name, data) {
  if (isObject(data)) {
    element[name] = data;
  } else if (element.dataset) {
    element.dataset[name] = data;
  } else {
    element.setAttribute('data-' + hyphenate(name), data);
  }
}

/**
 * Remove data from the given element.
 * @param {Element} element - The target element.
 * @param {string} name - The data key to remove.
 */
function removeData(element, name) {
  if (isObject(element[name])) {
    try {
      delete element[name];
    } catch (e) {
      element[name] = undefined;
    }
  } else if (element.dataset) {
    // #128 Safari not allows to delete dataset property
    try {
      delete element.dataset[name];
    } catch (e) {
      element.dataset[name] = undefined;
    }
  } else {
    element.removeAttribute('data-' + hyphenate(name));
  }
}

var REGEXP_SPACES = /\s\s*/;
var onceSupported = function () {
  var supported = false;

  if (IN_BROWSER) {
    var once = false;
    var listener = function listener() {};
    var options = Object.defineProperty({}, 'once', {
      get: function get$$1() {
        supported = true;
        return once;
      },

      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function set$$1(value) {
        once = value;
      }
    });

    WINDOW.addEventListener('test', listener, options);
    WINDOW.removeEventListener('test', listener, options);
  }

  return supported;
}();

/**
 * Remove event listener from the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */
function removeListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var handler = listener;

  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (!onceSupported) {
      var listeners = element.listeners;

      if (listeners && listeners[event] && listeners[event][listener]) {
        handler = listeners[event][listener];
        delete listeners[event][listener];

        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(listeners[event]).length === 0) {
          delete listeners[event];
        }

        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(listeners).length === 0) {
          delete element.listeners;
        }
      }
    }

    element.removeEventListener(event, handler, options);
  });
}

/**
 * Add event listener to the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Function} listener - The event listener.
 * @param {Object} options - The event options.
 */
function addListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _handler = listener;

  type.trim().split(REGEXP_SPACES).forEach(function (event) {
    if (options.once && !onceSupported) {
      var _element$listeners = element.listeners,
          listeners = _element$listeners === undefined ? {} : _element$listeners;

      _handler = function handler() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        delete listeners[event][listener];
        element.removeEventListener(event, _handler, options);
        listener.apply(element, args);
      };

      if (!listeners[event]) {
        listeners[event] = {};
      }

      if (listeners[event][listener]) {
        element.removeEventListener(event, listeners[event][listener], options);
      }

      listeners[event][listener] = _handler;
      element.listeners = listeners;
    }

    element.addEventListener(event, _handler, options);
  });
}

/**
 * Dispatch event on the target element.
 * @param {Element} element - The event target.
 * @param {string} type - The event type(s).
 * @param {Object} data - The additional event data.
 * @returns {boolean} Indicate if the event is default prevented or not.
 */
function dispatchEvent(element, type, data) {
  var event = void 0;

  // Event and CustomEvent on IE9-11 are global objects, not constructors
  if (isFunction(Event) && isFunction(CustomEvent)) {
    event = new CustomEvent(type, {
      detail: data,
      bubbles: true,
      cancelable: true
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(type, true, true, data);
  }

  return element.dispatchEvent(event);
}

/**
 * Get the offset base on the document.
 * @param {Element} element - The target element.
 * @returns {Object} The offset data.
 */
function getOffset(element) {
  var box = element.getBoundingClientRect();

  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}

/**
 * Get transforms base on the given object.
 * @param {Object} obj - The target object.
 * @returns {string} A string contains transform values.
 */
function getTransforms(_ref) {
  var rotate = _ref.rotate,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      translateX = _ref.translateX,
      translateY = _ref.translateY;

  var values = [];

  if (isNumber(translateX) && translateX !== 0) {
    values.push('translateX(' + translateX + 'px)');
  }

  if (isNumber(translateY) && translateY !== 0) {
    values.push('translateY(' + translateY + 'px)');
  }

  // Rotate should come first before scale to match orientation transform
  if (isNumber(rotate) && rotate !== 0) {
    values.push('rotate(' + rotate + 'deg)');
  }

  if (isNumber(scaleX) && scaleX !== 1) {
    values.push('scaleX(' + scaleX + ')');
  }

  if (isNumber(scaleY) && scaleY !== 1) {
    values.push('scaleY(' + scaleY + ')');
  }

  var transform = values.length ? values.join(' ') : 'none';

  return {
    WebkitTransform: transform,
    msTransform: transform,
    transform: transform
  };
}

/**
 * Get an image name from an image url.
 * @param {string} url - The target url.
 * @example
 * // picture.jpg
 * getImageNameFromURL('http://domain.com/path/to/picture.jpg?size=1280×960')
 * @returns {string} A string contains the image name.
 */
function getImageNameFromURL(url) {
  return isString(url) ? url.replace(/^.*\//, '').replace(/[?&#].*$/, '') : '';
}

var IS_SAFARI = WINDOW.navigator && /(Macintosh|iPhone|iPod|iPad).*AppleWebKit/i.test(WINDOW.navigator.userAgent);

/**
 * Get an image's natural sizes.
 * @param {string} image - The target image.
 * @param {Function} callback - The callback function.
 * @returns {HTMLImageElement} The new image.
 */
function getImageNaturalSizes(image, callback) {
  var newImage = document.createElement('img');

  // Modern browsers (except Safari)
  if (image.naturalWidth && !IS_SAFARI) {
    callback(image.naturalWidth, image.naturalHeight);
    return newImage;
  }

  var body = document.body || document.documentElement;

  newImage.onload = function () {
    callback(newImage.width, newImage.height);

    if (!IS_SAFARI) {
      body.removeChild(newImage);
    }
  };

  newImage.src = image.src;

  // iOS Safari will convert the image automatically
  // with its orientation once append it into DOM
  if (!IS_SAFARI) {
    newImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
    body.appendChild(newImage);
  }

  return newImage;
}

/**
 * Get the related class name of a responsive type number.
 * @param {string} type - The responsive type.
 * @returns {string} The related class name.
 */
function getResponsiveClass(type) {
  switch (type) {
    case 2:
      return CLASS_HIDE_XS_DOWN;

    case 3:
      return CLASS_HIDE_SM_DOWN;

    case 4:
      return CLASS_HIDE_MD_DOWN;

    default:
      return '';
  }
}

/**
 * Get the max ratio of a group of pointers.
 * @param {string} pointers - The target pointers.
 * @returns {number} The result ratio.
 */
function getMaxZoomRatio(pointers) {
  var pointers2 = assign({}, pointers);
  var ratios = [];

  forEach(pointers, function (pointer, pointerId) {
    delete pointers2[pointerId];

    forEach(pointers2, function (pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX);
      var y1 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x1 * x1 + y1 * y1);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;

      ratios.push(ratio);
    });
  });

  ratios.sort(function (a, b) {
    return Math.abs(a) < Math.abs(b);
  });

  return ratios[0];
}

/**
 * Get a pointer from an event object.
 * @param {Object} event - The target event object.
 * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
 * @returns {Object} The result pointer contains start and/or end point coordinates.
 */
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX,
      pageY = _ref2.pageY;

  var end = {
    endX: pageX,
    endY: pageY
  };

  return endOnly ? end : assign({
    startX: pageX,
    startY: pageY
  }, end);
}

/**
 * Get the center point coordinate of a group of pointers.
 * @param {Object} pointers - The target pointers.
 * @returns {Object} The center point coordinate.
 */
function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count = 0;

  forEach(pointers, function (_ref3) {
    var startX = _ref3.startX,
        startY = _ref3.startY;

    pageX += startX;
    pageY += startY;
    count += 1;
  });

  pageX /= count;
  pageY /= count;

  return {
    pageX: pageX,
    pageY: pageY
  };
}

var render = {
  render: function render() {
    this.initContainer();
    this.initViewer();
    this.initList();
    this.renderViewer();
  },
  initContainer: function initContainer() {
    this.containerData = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },
  initViewer: function initViewer() {
    var options = this.options,
        parent = this.parent;

    var viewerData = void 0;

    if (options.inline) {
      viewerData = {
        width: Math.max(parent.offsetWidth, options.minWidth),
        height: Math.max(parent.offsetHeight, options.minHeight)
      };

      this.parentData = viewerData;
    }

    if (this.fulled || !viewerData) {
      viewerData = this.containerData;
    }

    this.viewerData = assign({}, viewerData);
  },
  renderViewer: function renderViewer() {
    if (this.options.inline && !this.fulled) {
      setStyle(this.viewer, this.viewerData);
    }
  },
  initList: function initList() {
    var _this = this;

    var element = this.element,
        options = this.options,
        list = this.list;

    var items = [];

    forEach(this.images, function (image, i) {
      var src = image.src;

      var alt = image.alt || getImageNameFromURL(src);
      var url = options.url;

      if (isString(url)) {
        url = image.getAttribute(url);
      } else if (isFunction(url)) {
        url = url.call(_this, image);
      }

      if (src || url) {
        items.push('<li>' + '<img' + (' src="' + (src || url) + '"') + ' role="button"' + ' data-viewer-action="view"' + (' data-index="' + i + '"') + (' data-original-url="' + (url || src) + '"') + (' alt="' + alt + '"') + '>' + '</li>');
      }
    });

    list.innerHTML = items.join('');
    this.items = list.getElementsByTagName('li');
    forEach(this.items, function (item) {
      var image = item.firstElementChild;

      setData(image, 'filled', true);

      if (options.loading) {
        addClass(item, CLASS_LOADING);
      }

      addListener(image, EVENT_LOAD, function (event) {
        if (options.loading) {
          removeClass(item, CLASS_LOADING);
        }

        _this.loadImage(event);
      }, {
        once: true
      });
    });

    if (options.transition) {
      addListener(element, EVENT_VIEWED, function () {
        addClass(list, CLASS_TRANSITION);
      }, {
        once: true
      });
    }
  },
  renderList: function renderList(index) {
    var i = index || this.index;
    var width = this.items[i].offsetWidth || 30;
    var outerWidth = width + 1; // 1 pixel of `margin-left` width

    // Place the active item in the center of the screen
    setStyle(this.list, assign({
      width: outerWidth * this.length
    }, getTransforms({
      translateX: (this.viewerData.width - width) / 2 - outerWidth * i
    })));
  },
  resetList: function resetList() {
    var list = this.list;

    list.innerHTML = '';
    removeClass(list, CLASS_TRANSITION);
    setStyle(list, getTransforms({
      translateX: 0
    }));
  },
  initImage: function initImage(done) {
    var _this2 = this;

    var options = this.options,
        image = this.image,
        viewerData = this.viewerData;

    var footerHeight = this.footer.offsetHeight;
    var viewerWidth = viewerData.width;
    var viewerHeight = Math.max(viewerData.height - footerHeight, footerHeight);
    var oldImageData = this.imageData || {};
    var sizingImage = void 0;

    this.imageInitializing = {
      abort: function abort() {
        sizingImage.onload = null;
      }
    };

    sizingImage = getImageNaturalSizes(image, function (naturalWidth, naturalHeight) {
      var aspectRatio = naturalWidth / naturalHeight;
      var width = viewerWidth;
      var height = viewerHeight;

      _this2.imageInitializing = false;

      if (viewerHeight * aspectRatio > viewerWidth) {
        height = viewerWidth / aspectRatio;
      } else {
        width = viewerHeight * aspectRatio;
      }

      width = Math.min(width * 0.9, naturalWidth);
      height = Math.min(height * 0.9, naturalHeight);

      var imageData = {
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        aspectRatio: aspectRatio,
        ratio: width / naturalWidth,
        width: width,
        height: height,
        left: (viewerWidth - width) / 2,
        top: (viewerHeight - height) / 2
      };
      var initialImageData = assign({}, imageData);

      if (options.rotatable) {
        imageData.rotate = oldImageData.rotate || 0;
        initialImageData.rotate = 0;
      }

      if (options.scalable) {
        imageData.scaleX = oldImageData.scaleX || 1;
        imageData.scaleY = oldImageData.scaleY || 1;
        initialImageData.scaleX = 1;
        initialImageData.scaleY = 1;
      }

      _this2.imageData = imageData;
      _this2.initialImageData = initialImageData;

      if (done) {
        done();
      }
    });
  },
  renderImage: function renderImage(done) {
    var _this3 = this;

    var image = this.image,
        imageData = this.imageData;

    setStyle(image, assign({
      width: imageData.width,
      height: imageData.height,
      marginLeft: imageData.left,
      marginTop: imageData.top
    }, getTransforms(imageData)));

    if (done) {
      if ((this.viewing || this.zooming) && this.options.transition) {
        var onTransitionEnd = function onTransitionEnd() {
          _this3.imageRendering = false;
          done();
        };

        this.imageRendering = {
          abort: function abort() {
            removeListener(image, EVENT_TRANSITION_END, onTransitionEnd);
          }
        };

        addListener(image, EVENT_TRANSITION_END, onTransitionEnd, {
          once: true
        });
      } else {
        done();
      }
    }
  },
  resetImage: function resetImage() {
    // this.image only defined after viewed
    if (this.viewing || this.viewed) {
      var image = this.image;

      if (this.viewing) {
        this.viewing.abort();
      }

      image.parentNode.removeChild(image);
      this.image = null;
    }
  }
};

var events = {
  bind: function bind() {
    var canvas = this.canvas,
        element = this.element,
        viewer = this.viewer;

    addListener(viewer, EVENT_CLICK, this.onClick = this.click.bind(this));
    addListener(viewer, EVENT_WHEEL, this.onWheel = this.wheel.bind(this));
    addListener(viewer, EVENT_DRAG_START, this.onDragStart = this.dragstart.bind(this));

    if (this.options.toggleOnDblclick) {
      addListener(canvas, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
    }

    addListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown = this.pointerdown.bind(this));
    addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onPointerMove = this.pointermove.bind(this));
    addListener(element.ownerDocument, EVENT_POINTER_UP, this.onPointerUp = this.pointerup.bind(this));
    addListener(element.ownerDocument, EVENT_KEY_DOWN, this.onKeyDown = this.keydown.bind(this));
    addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
  },
  unbind: function unbind() {
    var canvas = this.canvas,
        element = this.element,
        viewer = this.viewer;

    removeListener(viewer, EVENT_CLICK, this.onClick);
    removeListener(viewer, EVENT_WHEEL, this.onWheel);
    removeListener(viewer, EVENT_DRAG_START, this.onDragStart);

    if (this.options.toggleOnDblclick) {
      removeListener(canvas, EVENT_DBLCLICK, this.onDblclick);
    }

    removeListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown);
    removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onPointerMove);
    removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onPointerUp);
    removeListener(element.ownerDocument, EVENT_KEY_DOWN, this.onKeyDown);
    removeListener(window, EVENT_RESIZE, this.onResize);
  }
};

var handlers = {
  click: function click(_ref) {
    var target = _ref.target;
    var options = this.options,
        imageData = this.imageData;

    var action = getData(target, DATA_ACTION);

    switch (action) {
      case 'mix':
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          } else {
            this.full();
          }
        } else {
          this.hide();
        }

        break;

      case 'hide':
        this.hide();
        break;

      case 'view':
        this.view(getData(target, 'index'));
        break;

      case 'zoom-in':
        this.zoom(0.1, true);
        break;

      case 'zoom-out':
        this.zoom(-0.1, true);
        break;

      case 'one-to-one':
        this.toggle();
        break;

      case 'reset':
        this.reset();
        break;

      case 'prev':
        this.prev(options.loop);
        break;

      case 'play':
        this.play(options.fullscreen);
        break;

      case 'next':
        this.next(options.loop);
        break;

      case 'rotate-left':
        this.rotate(-90);
        break;

      case 'rotate-right':
        this.rotate(90);
        break;

      case 'flip-horizontal':
        this.scaleX(-imageData.scaleX || -1);
        break;

      case 'flip-vertical':
        this.scaleY(-imageData.scaleY || -1);
        break;

      default:
        if (this.played) {
          this.stop();
        }
    }
  },
  dblclick: function dblclick(event) {
    if (event.target.parentElement === this.canvas) {
      this.toggle();
    }
  },
  load: function load() {
    var _this = this;

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }

    var element = this.element,
        options = this.options,
        image = this.image,
        index = this.index,
        viewerData = this.viewerData;

    removeClass(image, CLASS_INVISIBLE);

    if (options.loading) {
      removeClass(this.canvas, CLASS_LOADING);
    }

    image.style.cssText = 'height:0;' + ('margin-left:' + viewerData.width / 2 + 'px;') + ('margin-top:' + viewerData.height / 2 + 'px;') + 'max-width:none!important;' + 'position:absolute;' + 'width:0;';

    this.initImage(function () {
      toggleClass(image, CLASS_MOVE, options.movable);
      toggleClass(image, CLASS_TRANSITION, options.transition);

      _this.renderImage(function () {
        _this.viewed = true;
        _this.viewing = false;

        if (isFunction(options.viewed)) {
          addListener(element, EVENT_VIEWED, options.viewed, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_VIEWED, {
          originalImage: _this.images[index],
          index: index,
          image: image
        });
      });
    });
  },
  loadImage: function loadImage(e) {
    var image = e.target;
    var parent = image.parentNode;
    var parentWidth = parent.offsetWidth || 30;
    var parentHeight = parent.offsetHeight || 50;
    var filled = !!getData(image, 'filled');

    getImageNaturalSizes(image, function (naturalWidth, naturalHeight) {
      var aspectRatio = naturalWidth / naturalHeight;
      var width = parentWidth;
      var height = parentHeight;

      if (parentHeight * aspectRatio > parentWidth) {
        if (filled) {
          width = parentHeight * aspectRatio;
        } else {
          height = parentWidth / aspectRatio;
        }
      } else if (filled) {
        height = parentWidth / aspectRatio;
      } else {
        width = parentHeight * aspectRatio;
      }

      setStyle(image, assign({
        width: width,
        height: height
      }, getTransforms({
        translateX: (parentWidth - width) / 2,
        translateY: (parentHeight - height) / 2
      })));
    });
  },
  keydown: function keydown(e) {
    var options = this.options;

    if (!this.fulled || !options.keyboard) {
      return;
    }

    switch (e.keyCode || e.which || e.charCode) {
      // Escape
      case 27:
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          }
        } else {
          this.hide();
        }

        break;

      // Space
      case 32:
        if (this.played) {
          this.stop();
        }

        break;

      // ArrowLeft
      case 37:
        this.prev(options.loop);
        break;

      // ArrowUp
      case 38:
        // Prevent scroll on Firefox
        e.preventDefault();

        // Zoom in
        this.zoom(options.zoomRatio, true);
        break;

      // ArrowRight
      case 39:
        this.next(options.loop);
        break;

      // ArrowDown
      case 40:
        // Prevent scroll on Firefox
        e.preventDefault();

        // Zoom out
        this.zoom(-options.zoomRatio, true);
        break;

      // Ctrl + 0
      case 48:
      // Fall through

      // Ctrl + 1
      // eslint-disable-next-line no-fallthrough
      case 49:
        if (e.ctrlKey) {
          e.preventDefault();
          this.toggle();
        }

        break;

      default:
    }
  },
  dragstart: function dragstart(e) {
    if (e.target.tagName.toLowerCase() === 'img') {
      e.preventDefault();
    }
  },
  pointerdown: function pointerdown(e) {
    var options = this.options,
        pointers = this.pointers;

    if (!this.viewed || this.showing || this.viewing || this.hiding) {
      return;
    }

    // This line is required for preventing page zooming in iOS browsers
    e.preventDefault();

    if (e.changedTouches) {
      forEach(e.changedTouches, function (touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      pointers[e.pointerId || 0] = getPointer(e);
    }

    var action = options.movable ? ACTION_MOVE : false;

    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pointers).length > 1) {
      action = ACTION_ZOOM;
    } else if ((e.pointerType === 'touch' || e.type === 'touchstart') && this.isSwitchable()) {
      action = ACTION_SWITCH;
    }

    if (options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      removeClass(this.image, CLASS_TRANSITION);
    }

    this.action = action;
  },
  pointermove: function pointermove(e) {
    var pointers = this.pointers,
        action = this.action;

    if (!this.viewed || !action) {
      return;
    }

    e.preventDefault();

    if (e.changedTouches) {
      forEach(e.changedTouches, function (touch) {
        assign(pointers[touch.identifier], getPointer(touch, true));
      });
    } else {
      assign(pointers[e.pointerId || 0], getPointer(e, true));
    }

    this.change(e);
  },
  pointerup: function pointerup(e) {
    var action = this.action,
        pointers = this.pointers;

    if (e.changedTouches) {
      forEach(e.changedTouches, function (touch) {
        delete pointers[touch.identifier];
      });
    } else {
      delete pointers[e.pointerId || 0];
    }

    if (!action) {
      return;
    }

    e.preventDefault();

    if (this.options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      addClass(this.image, CLASS_TRANSITION);
    }

    this.action = false;
  },
  resize: function resize() {
    var _this2 = this;

    if (!this.isShown || this.hiding) {
      return;
    }

    this.initContainer();
    this.initViewer();
    this.renderViewer();
    this.renderList();

    if (this.viewed) {
      this.initImage(function () {
        _this2.renderImage();
      });
    }

    if (this.played) {
      if (this.options.fullscreen && this.fulled && !document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
        this.stop();
        return;
      }

      forEach(this.player.getElementsByTagName('img'), function (image) {
        addListener(image, EVENT_LOAD, _this2.loadImage.bind(_this2), {
          once: true
        });
        dispatchEvent(image, EVENT_LOAD);
      });
    }
  },
  wheel: function wheel(e) {
    var _this3 = this;

    if (!this.viewed) {
      return;
    }

    e.preventDefault();

    // Limit wheel speed to prevent zoom too fast
    if (this.wheeling) {
      return;
    }

    this.wheeling = true;

    setTimeout(function () {
      _this3.wheeling = false;
    }, 50);

    var ratio = Number(this.options.zoomRatio) || 0.1;
    var delta = 1;

    if (e.deltaY) {
      delta = e.deltaY > 0 ? 1 : -1;
    } else if (e.wheelDelta) {
      delta = -e.wheelDelta / 120;
    } else if (e.detail) {
      delta = e.detail > 0 ? 1 : -1;
    }

    this.zoom(-delta * ratio, true, e);
  }
};

var methods = {
  /** Show the viewer (only available in modal mode)
   * @param {boolean} [immediate=false] - Indicates if show the viewer immediately or not.
   * @returns {Viewer} this
   */
  show: function show() {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var element = this.element,
        options = this.options;

    if (options.inline || this.showing || this.isShown || this.showing) {
      return this;
    }

    if (!this.ready) {
      this.build();

      if (this.ready) {
        this.show(immediate);
      }

      return this;
    }

    if (isFunction(options.show)) {
      addListener(element, EVENT_SHOW, options.show, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_SHOW) === false || !this.ready) {
      return this;
    }

    if (this.hiding) {
      this.transitioning.abort();
    }

    this.showing = true;
    this.open();

    var viewer = this.viewer;

    removeClass(viewer, CLASS_HIDE);

    if (options.transition && !immediate) {
      var shown = this.shown.bind(this);

      this.transitioning = {
        abort: function abort() {
          removeListener(viewer, EVENT_TRANSITION_END, shown);
          removeClass(viewer, CLASS_IN);
        }
      };

      addClass(viewer, CLASS_TRANSITION);

      // Force reflow to enable CSS3 transition
      // eslint-disable-next-line
      viewer.offsetWidth;
      addListener(viewer, EVENT_TRANSITION_END, shown, {
        once: true
      });
      addClass(viewer, CLASS_IN);
    } else {
      addClass(viewer, CLASS_IN);
      this.shown();
    }

    return this;
  },

  /**
   * Hide the viewer (only available in modal mode)
   * @param {boolean} [immediate=false] - Indicates if hide the viewer immediately or not.
   * @returns {Viewer} this
   */
  hide: function hide() {
    var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var element = this.element,
        options = this.options;

    if (options.inline || this.hiding || !(this.isShown || this.showing)) {
      return this;
    }

    if (isFunction(options.hide)) {
      addListener(element, EVENT_HIDE, options.hide, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_HIDE) === false) {
      return this;
    }

    if (this.showing) {
      this.transitioning.abort();
    }

    this.hiding = true;

    if (this.played) {
      this.stop();
    } else if (this.viewing) {
      this.viewing.abort();
    }

    var viewer = this.viewer;

    if (options.transition && !immediate) {
      var hidden = this.hidden.bind(this);
      var hide = function hide() {
        addListener(viewer, EVENT_TRANSITION_END, hidden, {
          once: true
        });
        removeClass(viewer, CLASS_IN);
      };

      this.transitioning = {
        abort: function abort() {
          if (this.viewed) {
            removeListener(this.image, EVENT_TRANSITION_END, hide);
          } else {
            removeListener(viewer, EVENT_TRANSITION_END, hidden);
          }
        }
      };

      if (this.viewed) {
        addListener(this.image, EVENT_TRANSITION_END, hide, {
          once: true
        });
        this.zoomTo(0, false, false, true);
      } else {
        hide();
      }
    } else {
      removeClass(viewer, CLASS_IN);
      this.hidden();
    }

    return this;
  },

  /**
   * View one of the images with image's index
   * @param {number} index - The index of the image to view.
   * @returns {Viewer} this
   */
  view: function view() {
    var _this = this;

    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.initialViewIndex;

    index = Number(index) || 0;

    if (!this.isShown) {
      this.index = index;
      return this.show();
    }

    if (this.hiding || this.played || index < 0 || index >= this.length || this.viewed && index === this.index) {
      return this;
    }

    if (this.viewing) {
      this.viewing.abort();
    }

    var element = this.element,
        options = this.options,
        title = this.title,
        canvas = this.canvas;

    var item = this.items[index];
    var img = item.querySelector('img');
    var url = getData(img, 'originalUrl');
    var alt = img.getAttribute('alt');
    var image = document.createElement('img');

    image.src = url;
    image.alt = alt;

    if (isFunction(options.view)) {
      addListener(element, EVENT_VIEW, options.view, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_VIEW, {
      originalImage: this.images[index],
      index: index,
      image: image
    }) === false || !this.isShown || this.hiding || this.played) {
      return this;
    }

    this.image = image;
    this.items[this.index] && removeClass(this.items[this.index], CLASS_ACTIVE);
    addClass(item, CLASS_ACTIVE);
    this.viewed = false;
    this.index = index;
    this.imageData = {};
    addClass(image, CLASS_INVISIBLE);

    if (options.loading) {
      addClass(canvas, CLASS_LOADING);
    }

    canvas.innerHTML = '';
    canvas.appendChild(image);

    // Center current item
    this.renderList();

    // Clear title
    title.innerHTML = '';

    // Generate title after viewed
    var onViewed = function onViewed() {
      var imageData = _this.imageData;

      var render = Array.isArray(options.title) ? options.title[1] : options.title;

      title.innerHTML = isFunction(render) ? render.call(_this, image, imageData) : alt + ' (' + imageData.naturalWidth + ' \xD7 ' + imageData.naturalHeight + ')';
    };
    var onLoad = void 0;

    addListener(element, EVENT_VIEWED, onViewed, {
      once: true
    });

    this.viewing = {
      abort: function abort() {
        removeListener(element, EVENT_VIEWED, onViewed);

        if (image.complete) {
          if (this.imageRendering) {
            this.imageRendering.abort();
          } else if (this.imageInitializing) {
            this.imageInitializing.abort();
          }
        } else {
          removeListener(image, EVENT_LOAD, onLoad);

          if (this.timeout) {
            clearTimeout(this.timeout);
          }
        }
      }
    };

    if (image.complete) {
      this.load();
    } else {
      addListener(image, EVENT_LOAD, onLoad = this.load.bind(this), {
        once: true
      });

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      // Make the image visible if it fails to load within 1s
      this.timeout = setTimeout(function () {
        removeClass(image, CLASS_INVISIBLE);
        _this.timeout = false;
      }, 1000);
    }

    return this;
  },

  /**
   * View the previous image
   * @param {boolean} [loop=false] - Indicate if view the last one
   * when it is the first one at present.
   * @returns {Viewer} this
   */
  prev: function prev() {
    var loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var index = this.index - 1;

    if (index < 0) {
      index = loop ? this.length - 1 : 0;
    }

    this.view(index);
    return this;
  },

  /**
   * View the next image
   * @param {boolean} [loop=false] - Indicate if view the first one
   * when it is the last one at present.
   * @returns {Viewer} this
   */
  next: function next() {
    var loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var maxIndex = this.length - 1;
    var index = this.index + 1;

    if (index > maxIndex) {
      index = loop ? 0 : maxIndex;
    }

    this.view(index);
    return this;
  },

  /**
   * Move the image with relative offsets.
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} offsetY - The relative offset distance on the y-axis.
   * @returns {Viewer} this
   */
  move: function move(offsetX, offsetY) {
    var imageData = this.imageData;

    this.moveTo(isUndefined(offsetX) ? offsetX : imageData.left + Number(offsetX), isUndefined(offsetY) ? offsetY : imageData.top + Number(offsetY));

    return this;
  },

  /**
   * Move the image to an absolute point.
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Viewer} this
   */
  moveTo: function moveTo(x) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    var imageData = this.imageData;

    x = Number(x);
    y = Number(y);

    if (this.viewed && !this.played && this.options.movable) {
      var changed = false;

      if (isNumber(x)) {
        imageData.left = x;
        changed = true;
      }

      if (isNumber(y)) {
        imageData.top = y;
        changed = true;
      }

      if (changed) {
        this.renderImage();
      }
    }

    return this;
  },

  /**
   * Zoom the image with a relative ratio.
   * @param {number} ratio - The target ratio.
   * @param {boolean} [hasTooltip=false] - Indicates if it has a tooltip or not.
   * @param {Event} [_originalEvent=null] - The original event if any.
   * @returns {Viewer} this
   */
  zoom: function zoom(ratio) {
    var hasTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _originalEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var imageData = this.imageData;

    ratio = Number(ratio);

    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }

    this.zoomTo(imageData.width * ratio / imageData.naturalWidth, hasTooltip, _originalEvent);

    return this;
  },

  /**
   * Zoom the image to an absolute ratio.
   * @param {number} ratio - The target ratio.
   * @param {boolean} [hasTooltip=false] - Indicates if it has a tooltip or not.
   * @param {Event} [_originalEvent=null] - The original event if any.
   * @param {Event} [_zoomable=false] - Indicates if the current zoom is available or not.
   * @returns {Viewer} this
   */
  zoomTo: function zoomTo(ratio) {
    var hasTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _this2 = this;

    var _originalEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var _zoomable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var element = this.element,
        options = this.options,
        pointers = this.pointers,
        imageData = this.imageData;

    ratio = Math.max(0, ratio);

    if (isNumber(ratio) && this.viewed && !this.played && (_zoomable || options.zoomable)) {
      if (!_zoomable) {
        var minZoomRatio = Math.max(0.01, options.minZoomRatio);
        var maxZoomRatio = Math.min(100, options.maxZoomRatio);

        ratio = Math.min(Math.max(ratio, minZoomRatio), maxZoomRatio);
      }

      if (_originalEvent && ratio > 0.95 && ratio < 1.05) {
        ratio = 1;
      }

      var newWidth = imageData.naturalWidth * ratio;
      var newHeight = imageData.naturalHeight * ratio;
      var oldRatio = imageData.width / imageData.naturalWidth;

      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom, {
          once: true
        });
      }

      if (dispatchEvent(element, EVENT_ZOOM, {
        ratio: ratio,
        oldRatio: oldRatio,
        originalEvent: _originalEvent
      }) === false) {
        return this;
      }

      this.zooming = true;

      if (_originalEvent) {
        var offset = getOffset(this.viewer);
        var center = pointers && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };

        // Zoom from the triggering point of the event
        imageData.left -= (newWidth - imageData.width) * ((center.pageX - offset.left - imageData.left) / imageData.width);
        imageData.top -= (newHeight - imageData.height) * ((center.pageY - offset.top - imageData.top) / imageData.height);
      } else {
        // Zoom from the center of the image
        imageData.left -= (newWidth - imageData.width) / 2;
        imageData.top -= (newHeight - imageData.height) / 2;
      }

      imageData.width = newWidth;
      imageData.height = newHeight;
      imageData.ratio = ratio;
      this.renderImage(function () {
        _this2.zooming = false;

        if (isFunction(options.zoomed)) {
          addListener(element, EVENT_ZOOMED, options.zoomed, {
            once: true
          });
        }

        dispatchEvent(element, EVENT_ZOOMED, {
          ratio: ratio,
          oldRatio: oldRatio,
          originalEvent: _originalEvent
        });
      });

      if (hasTooltip) {
        this.tooltip();
      }
    }

    return this;
  },

  /**
   * Rotate the image with a relative degree.
   * @param {number} degree - The rotate degree.
   * @returns {Viewer} this
   */
  rotate: function rotate(degree) {
    this.rotateTo((this.imageData.rotate || 0) + Number(degree));

    return this;
  },

  /**
   * Rotate the image to an absolute degree.
   * @param {number} degree - The rotate degree.
   * @returns {Viewer} this
   */
  rotateTo: function rotateTo(degree) {
    var imageData = this.imageData;

    degree = Number(degree);

    if (isNumber(degree) && this.viewed && !this.played && this.options.rotatable) {
      imageData.rotate = degree;
      this.renderImage();
    }

    return this;
  },

  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Viewer} this
   */
  scaleX: function scaleX(_scaleX) {
    this.scale(_scaleX, this.imageData.scaleY);

    return this;
  },

  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Viewer} this
   */
  scaleY: function scaleY(_scaleY) {
    this.scale(this.imageData.scaleX, _scaleY);

    return this;
  },

  /**
   * Scale the image.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Viewer} this
   */
  scale: function scale(scaleX) {
    var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
    var imageData = this.imageData;

    scaleX = Number(scaleX);
    scaleY = Number(scaleY);

    if (this.viewed && !this.played && this.options.scalable) {
      var changed = false;

      if (isNumber(scaleX)) {
        imageData.scaleX = scaleX;
        changed = true;
      }

      if (isNumber(scaleY)) {
        imageData.scaleY = scaleY;
        changed = true;
      }

      if (changed) {
        this.renderImage();
      }
    }

    return this;
  },

  /**
   * Play the images
   * @param {boolean} [fullscreen=false] - Indicate if request fullscreen or not.
   * @returns {Viewer} this
   */
  play: function play() {
    var _this3 = this;

    var fullscreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!this.isShown || this.played) {
      return this;
    }

    var options = this.options,
        player = this.player;

    var onLoad = this.loadImage.bind(this);
    var list = [];
    var total = 0;
    var index = 0;

    this.played = true;
    this.onLoadWhenPlay = onLoad;

    if (fullscreen) {
      this.requestFullscreen();
    }

    addClass(player, CLASS_SHOW);
    forEach(this.items, function (item, i) {
      var img = item.querySelector('img');
      var image = document.createElement('img');

      image.src = getData(img, 'originalUrl');
      image.alt = img.getAttribute('alt');
      total += 1;
      addClass(image, CLASS_FADE);
      toggleClass(image, CLASS_TRANSITION, options.transition);

      if (hasClass(item, CLASS_ACTIVE)) {
        addClass(image, CLASS_IN);
        index = i;
      }

      list.push(image);
      addListener(image, EVENT_LOAD, onLoad, {
        once: true
      });
      player.appendChild(image);
    });

    if (isNumber(options.interval) && options.interval > 0) {
      var play = function play() {
        _this3.playing = setTimeout(function () {
          removeClass(list[index], CLASS_IN);
          index += 1;
          index = index < total ? index : 0;
          addClass(list[index], CLASS_IN);
          play();
        }, options.interval);
      };

      if (total > 1) {
        play();
      }
    }

    return this;
  },

  // Stop play
  stop: function stop() {
    var _this4 = this;

    if (!this.played) {
      return this;
    }

    var player = this.player;

    this.played = false;
    clearTimeout(this.playing);
    forEach(player.getElementsByTagName('img'), function (image) {
      removeListener(image, EVENT_LOAD, _this4.onLoadWhenPlay);
    });
    removeClass(player, CLASS_SHOW);
    player.innerHTML = '';
    this.exitFullscreen();

    return this;
  },

  // Enter modal mode (only available in inline mode)
  full: function full() {
    var _this5 = this;

    var options = this.options,
        viewer = this.viewer,
        image = this.image,
        list = this.list;

    if (!this.isShown || this.played || this.fulled || !options.inline) {
      return this;
    }

    this.fulled = true;
    this.open();
    addClass(this.button, CLASS_FULLSCREEN_EXIT);

    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);

      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }

    addClass(viewer, CLASS_FIXED);
    viewer.setAttribute('style', '');
    setStyle(viewer, {
      zIndex: options.zIndex
    });

    this.initContainer();
    this.viewerData = assign({}, this.containerData);
    this.renderList();

    if (this.viewed) {
      this.initImage(function () {
        _this5.renderImage(function () {
          if (options.transition) {
            setTimeout(function () {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }

    return this;
  },

  // Exit modal mode (only available in inline mode)
  exit: function exit() {
    var _this6 = this;

    var options = this.options,
        viewer = this.viewer,
        image = this.image,
        list = this.list;

    if (!this.isShown || this.played || !this.fulled || !options.inline) {
      return this;
    }

    this.fulled = false;
    this.close();
    removeClass(this.button, CLASS_FULLSCREEN_EXIT);

    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);

      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }

    removeClass(viewer, CLASS_FIXED);
    setStyle(viewer, {
      zIndex: options.zIndexInline
    });

    this.viewerData = assign({}, this.parentData);
    this.renderViewer();
    this.renderList();

    if (this.viewed) {
      this.initImage(function () {
        _this6.renderImage(function () {
          if (options.transition) {
            setTimeout(function () {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }

    return this;
  },

  // Show the current ratio of the image with percentage
  tooltip: function tooltip() {
    var _this7 = this;

    var options = this.options,
        tooltipBox = this.tooltipBox,
        imageData = this.imageData;

    if (!this.viewed || this.played || !options.tooltip) {
      return this;
    }

    tooltipBox.textContent = Math.round(imageData.ratio * 100) + '%';

    if (!this.tooltipping) {
      if (options.transition) {
        if (this.fading) {
          dispatchEvent(tooltipBox, EVENT_TRANSITION_END);
        }

        addClass(tooltipBox, CLASS_SHOW);
        addClass(tooltipBox, CLASS_FADE);
        addClass(tooltipBox, CLASS_TRANSITION);

        // Force reflow to enable CSS3 transition
        // eslint-disable-next-line
        tooltipBox.offsetWidth;
        addClass(tooltipBox, CLASS_IN);
      } else {
        addClass(tooltipBox, CLASS_SHOW);
      }
    } else {
      clearTimeout(this.tooltipping);
    }

    this.tooltipping = setTimeout(function () {
      if (options.transition) {
        addListener(tooltipBox, EVENT_TRANSITION_END, function () {
          removeClass(tooltipBox, CLASS_SHOW);
          removeClass(tooltipBox, CLASS_FADE);
          removeClass(tooltipBox, CLASS_TRANSITION);
          _this7.fading = false;
        }, {
          once: true
        });

        removeClass(tooltipBox, CLASS_IN);
        _this7.fading = true;
      } else {
        removeClass(tooltipBox, CLASS_SHOW);
      }

      _this7.tooltipping = false;
    }, 1000);

    return this;
  },

  // Toggle the image size between its natural size and initial size
  toggle: function toggle() {
    if (this.imageData.ratio === 1) {
      this.zoomTo(this.initialImageData.ratio, true);
    } else {
      this.zoomTo(1, true);
    }

    return this;
  },

  // Reset the image to its initial state
  reset: function reset() {
    if (this.viewed && !this.played) {
      this.imageData = assign({}, this.initialImageData);
      this.renderImage();
    }

    return this;
  },

  // Update viewer when images changed
  update: function update() {
    var element = this.element,
        options = this.options,
        isImg = this.isImg;

    // Destroy viewer if the target image was deleted

    if (isImg && !element.parentNode) {
      return this.destroy();
    }

    var images = [];

    forEach(isImg ? [element] : element.querySelectorAll('img'), function (image) {
      if (options.filter) {
        if (options.filter(image)) {
          images.push(image);
        }
      } else {
        images.push(image);
      }
    });

    if (!images.length) {
      return this;
    }

    this.images = images;
    this.length = images.length;

    if (this.ready) {
      var indexes = [];

      forEach(this.items, function (item, i) {
        var img = item.querySelector('img');
        var image = images[i];

        if (image) {
          if (image.src !== img.src) {
            indexes.push(i);
          }
        } else {
          indexes.push(i);
        }
      });

      setStyle(this.list, {
        width: 'auto'
      });

      this.initList();

      if (this.isShown) {
        if (this.length) {
          if (this.viewed) {
            var index = indexes.indexOf(this.index);

            if (index >= 0) {
              this.viewed = false;
              this.view(Math.max(this.index - (index + 1), 0));
            } else {
              addClass(this.items[this.index], CLASS_ACTIVE);
            }
          }
        } else {
          this.image = null;
          this.viewed = false;
          this.index = 0;
          this.imageData = {};
          this.canvas.innerHTML = '';
          this.title.innerHTML = '';
        }
      }
    } else {
      this.build();
    }

    return this;
  },

  // Destroy the viewer
  destroy: function destroy() {
    var element = this.element,
        options = this.options;

    if (!getData(element, NAMESPACE)) {
      return this;
    }

    this.destroyed = true;

    if (this.ready) {
      if (this.played) {
        this.stop();
      }

      if (options.inline) {
        if (this.fulled) {
          this.exit();
        }

        this.unbind();
      } else if (this.isShown) {
        if (this.viewing) {
          if (this.imageRendering) {
            this.imageRendering.abort();
          } else if (this.imageInitializing) {
            this.imageInitializing.abort();
          }
        }

        if (this.hiding) {
          this.transitioning.abort();
        }

        this.hidden();
      } else if (this.showing) {
        this.transitioning.abort();
        this.hidden();
      }

      this.ready = false;
      this.viewer.parentNode.removeChild(this.viewer);
    } else if (options.inline) {
      if (this.delaying) {
        this.delaying.abort();
      } else if (this.initializing) {
        this.initializing.abort();
      }
    }

    if (!options.inline) {
      removeListener(element, EVENT_CLICK, this.onStart);
    }

    removeData(element, NAMESPACE);
    return this;
  }
};

var others = {
  open: function open() {
    var body = this.body;

    addClass(body, CLASS_OPEN);

    body.style.paddingRight = this.scrollbarWidth + (parseFloat(this.initialBodyPaddingRight) || 0) + 'px';
  },
  close: function close() {
    var body = this.body;

    removeClass(body, CLASS_OPEN);
    body.style.paddingRight = this.initialBodyPaddingRight;
  },
  shown: function shown() {
    var element = this.element,
        options = this.options;

    this.fulled = true;
    this.isShown = true;
    this.render();
    this.bind();
    this.showing = false;

    if (isFunction(options.shown)) {
      addListener(element, EVENT_SHOWN, options.shown, {
        once: true
      });
    }

    if (dispatchEvent(element, EVENT_SHOWN) === false) {
      return;
    }

    if (this.ready && this.isShown && !this.hiding) {
      this.view(this.index);
    }
  },
  hidden: function hidden() {
    var element = this.element,
        options = this.options;

    this.fulled = false;
    this.viewed = false;
    this.isShown = false;
    this.close();
    this.unbind();
    addClass(this.viewer, CLASS_HIDE);
    this.resetList();
    this.resetImage();
    this.hiding = false;

    if (!this.destroyed) {
      if (isFunction(options.hidden)) {
        addListener(element, EVENT_HIDDEN, options.hidden, {
          once: true
        });
      }

      dispatchEvent(element, EVENT_HIDDEN);
    }
  },
  requestFullscreen: function requestFullscreen() {
    var document = this.element.ownerDocument;

    if (this.fulled && !document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      var documentElement = document.documentElement;

      if (documentElement.requestFullscreen) {
        documentElement.requestFullscreen();
      } else if (documentElement.msRequestFullscreen) {
        documentElement.msRequestFullscreen();
      } else if (documentElement.mozRequestFullScreen) {
        documentElement.mozRequestFullScreen();
      } else if (documentElement.webkitRequestFullscreen) {
        documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    }
  },
  exitFullscreen: function exitFullscreen() {
    if (this.fulled) {
      var document = this.element.ownerDocument;

      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  },
  change: function change(e) {
    var options = this.options,
        pointers = this.pointers;

    var pointer = pointers[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(pointers)[0]];
    var offsetX = pointer.endX - pointer.startX;
    var offsetY = pointer.endY - pointer.startY;

    switch (this.action) {
      // Move the current image
      case ACTION_MOVE:
        this.move(offsetX, offsetY);
        break;

      // Zoom the current image
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), false, e);
        break;

      case ACTION_SWITCH:
        {
          this.action = 'switched';

          var absoluteOffsetX = Math.abs(offsetX);

          if (absoluteOffsetX > 1 && absoluteOffsetX > Math.abs(offsetY)) {
            // Empty `pointers` as `touchend` event will not be fired after swiped in iOS browsers.
            this.pointers = {};

            if (offsetX > 1) {
              this.prev(options.loop);
            } else if (offsetX < -1) {
              this.next(options.loop);
            }
          }

          break;
        }

      default:
    }

    // Override
    forEach(pointers, function (p) {
      p.startX = p.endX;
      p.startY = p.endY;
    });
  },
  isSwitchable: function isSwitchable() {
    var imageData = this.imageData,
        viewerData = this.viewerData;

    return this.length > 1 && imageData.left >= 0 && imageData.top >= 0 && imageData.width <= viewerData.width && imageData.height <= viewerData.height;
  }
};

var AnotherViewer = WINDOW.Viewer;

var Viewer = function () {
  /**
   * Create a new Viewer.
   * @param {Element} element - The target element for viewing.
   * @param {Object} [options={}] - The configuration options.
   */
  function Viewer(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, Viewer);

    if (!element || element.nodeType !== 1) {
      throw new Error('The first argument is required and must be an element.');
    }

    this.element = element;
    this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
    this.action = false;
    this.fading = false;
    this.fulled = false;
    this.hiding = false;
    this.imageData = {};
    this.index = this.options.initialViewIndex;
    this.isImg = false;
    this.isShown = false;
    this.length = 0;
    this.played = false;
    this.playing = false;
    this.pointers = {};
    this.ready = false;
    this.showing = false;
    this.timeout = false;
    this.tooltipping = false;
    this.viewed = false;
    this.viewing = false;
    this.wheeling = false;
    this.zooming = false;
    this.init();
  }

  createClass(Viewer, [{
    key: 'init',
    value: function init() {
      var _this = this;

      var element = this.element,
          options = this.options;

      if (getData(element, NAMESPACE)) {
        return;
      }

      setData(element, NAMESPACE, this);

      var isImg = element.tagName.toLowerCase() === 'img';
      var images = [];

      forEach(isImg ? [element] : element.querySelectorAll('img'), function (image) {
        if (isFunction(options.filter)) {
          if (options.filter.call(_this, image)) {
            images.push(image);
          }
        } else {
          images.push(image);
        }
      });

      if (!images.length) {
        return;
      }

      this.isImg = isImg;
      this.length = images.length;
      this.images = images;

      var ownerDocument = element.ownerDocument;

      var body = ownerDocument.body || ownerDocument.documentElement;

      this.body = body;
      this.scrollbarWidth = window.innerWidth - ownerDocument.documentElement.clientWidth;
      this.initialBodyPaddingRight = window.getComputedStyle(body).paddingRight;

      // Override `transition` option if it is not supported
      if (isUndefined(document.createElement(NAMESPACE).style.transition)) {
        options.transition = false;
      }

      if (options.inline) {
        var count = 0;
        var progress = function progress() {
          count += 1;

          if (count === _this.length) {
            var timeout = void 0;

            _this.initializing = false;
            _this.delaying = {
              abort: function abort() {
                clearTimeout(timeout);
              }
            };

            // build asynchronously to keep `this.viewer` is accessible in `ready` event handler.
            timeout = setTimeout(function () {
              _this.delaying = false;
              _this.build();
            }, 0);
          }
        };

        this.initializing = {
          abort: function abort() {
            forEach(images, function (image) {
              if (!image.complete) {
                removeListener(image, EVENT_LOAD, progress);
              }
            });
          }
        };

        forEach(images, function (image) {
          if (image.complete) {
            progress();
          } else {
            addListener(image, EVENT_LOAD, progress, {
              once: true
            });
          }
        });
      } else {
        addListener(element, EVENT_CLICK, this.onStart = function (_ref) {
          var target = _ref.target;

          if (target.tagName.toLowerCase() === 'img') {
            _this.view(_this.images.indexOf(target));
          }
        });
      }
    }
  }, {
    key: 'build',
    value: function build() {
      if (this.ready) {
        return;
      }

      var element = this.element,
          options = this.options;

      var parent = element.parentNode;
      var template = document.createElement('div');

      template.innerHTML = TEMPLATE;

      var viewer = template.querySelector('.' + NAMESPACE + '-container');
      var title = viewer.querySelector('.' + NAMESPACE + '-title');
      var toolbar = viewer.querySelector('.' + NAMESPACE + '-toolbar');
      var navbar = viewer.querySelector('.' + NAMESPACE + '-navbar');
      var button = viewer.querySelector('.' + NAMESPACE + '-button');
      var canvas = viewer.querySelector('.' + NAMESPACE + '-canvas');

      this.parent = parent;
      this.viewer = viewer;
      this.title = title;
      this.toolbar = toolbar;
      this.navbar = navbar;
      this.button = button;
      this.canvas = canvas;
      this.footer = viewer.querySelector('.' + NAMESPACE + '-footer');
      this.tooltipBox = viewer.querySelector('.' + NAMESPACE + '-tooltip');
      this.player = viewer.querySelector('.' + NAMESPACE + '-player');
      this.list = viewer.querySelector('.' + NAMESPACE + '-list');

      addClass(title, !options.title ? CLASS_HIDE : getResponsiveClass(Array.isArray(options.title) ? options.title[0] : options.title));
      addClass(navbar, !options.navbar ? CLASS_HIDE : getResponsiveClass(options.navbar));
      toggleClass(button, CLASS_HIDE, !options.button);

      if (options.backdrop) {
        addClass(viewer, NAMESPACE + '-backdrop');

        if (!options.inline && options.backdrop === true) {
          setData(canvas, DATA_ACTION, 'hide');
        }
      }

      if (options.toolbar) {
        var list = document.createElement('ul');
        var custom = isPlainObject(options.toolbar);
        var zoomButtons = BUTTONS.slice(0, 3);
        var rotateButtons = BUTTONS.slice(7, 9);
        var scaleButtons = BUTTONS.slice(9);

        if (!custom) {
          addClass(toolbar, getResponsiveClass(options.toolbar));
        }

        forEach(custom ? options.toolbar : BUTTONS, function (value, index) {
          var deep = custom && isPlainObject(value);
          var name = custom ? hyphenate(index) : value;
          var show = deep && !isUndefined(value.show) ? value.show : value;

          if (!show || !options.zoomable && zoomButtons.indexOf(name) !== -1 || !options.rotatable && rotateButtons.indexOf(name) !== -1 || !options.scalable && scaleButtons.indexOf(name) !== -1) {
            return;
          }

          var size = deep && !isUndefined(value.size) ? value.size : value;
          var click = deep && !isUndefined(value.click) ? value.click : value;
          var item = document.createElement('li');

          item.setAttribute('role', 'button');
          addClass(item, NAMESPACE + '-' + name);

          if (!isFunction(click)) {
            setData(item, DATA_ACTION, name);
          }

          if (isNumber(show)) {
            addClass(item, getResponsiveClass(show));
          }

          if (['small', 'large'].indexOf(size) !== -1) {
            addClass(item, NAMESPACE + '-' + size);
          } else if (name === 'play') {
            addClass(item, NAMESPACE + '-large');
          }

          if (isFunction(click)) {
            addListener(item, EVENT_CLICK, click);
          }

          list.appendChild(item);
        });

        toolbar.appendChild(list);
      } else {
        addClass(toolbar, CLASS_HIDE);
      }

      if (!options.rotatable) {
        var rotates = toolbar.querySelectorAll('li[class*="rotate"]');

        addClass(rotates, CLASS_INVISIBLE);
        forEach(rotates, function (rotate) {
          toolbar.appendChild(rotate);
        });
      }

      if (options.inline) {
        addClass(button, CLASS_FULLSCREEN);
        setStyle(viewer, {
          zIndex: options.zIndexInline
        });

        if (window.getComputedStyle(parent).position === 'static') {
          setStyle(parent, {
            position: 'relative'
          });
        }

        parent.insertBefore(viewer, element.nextSibling);
      } else {
        addClass(button, CLASS_CLOSE);
        addClass(viewer, CLASS_FIXED);
        addClass(viewer, CLASS_FADE);
        addClass(viewer, CLASS_HIDE);

        setStyle(viewer, {
          zIndex: options.zIndex
        });

        var container = options.container;

        if (isString(container)) {
          container = element.ownerDocument.querySelector(container);
        }

        if (!container) {
          container = this.body;
        }

        container.appendChild(viewer);
      }

      if (options.inline) {
        this.render();
        this.bind();
        this.isShown = true;
      }

      this.ready = true;

      if (isFunction(options.ready)) {
        addListener(element, EVENT_READY, options.ready, {
          once: true
        });
      }

      if (dispatchEvent(element, EVENT_READY) === false) {
        this.ready = false;
        return;
      }

      if (this.ready && options.inline) {
        this.view(this.index);
      }
    }

    /**
     * Get the no conflict viewer class.
     * @returns {Viewer} The viewer class.
     */

  }], [{
    key: 'noConflict',
    value: function noConflict() {
      window.Viewer = AnotherViewer;
      return Viewer;
    }

    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */

  }, {
    key: 'setDefaults',
    value: function setDefaults(options) {
      assign(DEFAULTS, isPlainObject(options) && options);
    }
  }]);
  return Viewer;
}();

assign(Viewer.prototype, render, events, handlers, methods, others);

/* harmony default export */ __webpack_exports__["a"] = (Viewer);

/***/ }),

/***/ 1716:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LableResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(1717);



var LableResultConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0;

var initInstance = function initInstance(element) {
  instance = new LableResultConstructor({
    el: document.createElement('div')
  });
  // element.parentNode.insertBefore(instance.$el, element.nextSibling)
  element.appendChild(instance.$el);
};

var LableResult = function LableResult(element) {
  if (!instance) {
    initInstance(element);
    instance.width = element.offsetWidth;
    instance.height = element.offsetHeight;
    instance.container = element;
  }
  return LableResult;
};

LableResult.isInstance = function () {
  return !!instance;
};

LableResult.init = function (data, left, top, matrix) {
  instance.visible = true;
  instance.data = data;
  instance.left = left;
  instance.top = top;
  matrix && (instance.matrix = matrix);
  instance.init();
  return LableResult;
};

LableResult.getProducts = function () {
  return instance.canvasData.products;
};

LableResult.changeProduct = function (number) {
  instance.selectedProduct = instance.canvasData.productMap[number];
  instance.onProductNumberChange();
};

LableResult.update = function (left, top, matrix) {
  instance.left = left;
  instance.top = top;
  matrix && (instance.matrix = matrix);
  instance.update();
  return LableResult;
};

LableResult.show = function () {
  instance.visible = true;
  return LableResult;
};

LableResult.hide = function () {
  if (instance) {
    instance.visible = false;
  }
  return LableResult;
};

LableResult.destroy = function () {
  if (instance) {
    instance.destroy();
    instance = null;
  }
  return LableResult;
};

LableResult.destroy = function () {
  if (instance) {
    instance.$el.remove();
    instance.$destroy();
    instance = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (LableResult);


/***/ }),

/***/ 1717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(1579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7784b2d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1721);
function injectStyle (ssrContext) {
  __webpack_require__(1718)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7784b2d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7784b2d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1718:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1719);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("be395f6a", content, true, {});

/***/ }),

/***/ 1719:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".lable-config-panel[data-v-7784b2d8]{line-height:normal;font-size:14px;position:absolute;right:5px;top:0}.lable-config-panel .panel[data-v-7784b2d8]{background-color:hsla(0,0%,100%,.95)}.lable-color-picker[data-v-7784b2d8]{list-style:none;margin:0;padding:0}.lable-color-picker li[data-v-7784b2d8]{display:inline-block;padding-right:15px}.lable-color-picker li p[data-v-7784b2d8]{font-size:12px;margin-top:7px;margin-left:2px;margin-bottom:0}.lable-selected-path-data[data-v-7784b2d8]{margin-top:-5px}.lable-selected-path-data p[data-v-7784b2d8]{font-size:12px;margin-bottom:0;margin-top:5px;word-wrap:break-word;word-break:break-all}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/LableResult/src/main.vue"],"names":[],"mappings":"AACA,qCAAqC,mBAAmB,eAAe,kBAAkB,UAAU,KAAK,CACvG,AACD,4CAA4C,oCAAuC,CAClF,AACD,qCAAqC,gBAAgB,SAAW,SAAW,CAC1E,AACD,wCAAwC,qBAAqB,kBAAkB,CAC9E,AACD,0CAA0C,eAAe,eAAe,gBAAgB,eAAe,CACtG,AACD,2CAA2C,eAAe,CACzD,AACD,6CAA6C,eAAe,gBAAgB,eAAe,qBAAqB,oBAAoB,CACnI","file":"main.vue","sourcesContent":["\n.lable-config-panel[data-v-7784b2d8]{line-height:normal;font-size:14px;position:absolute;right:5px;top:0\n}\n.lable-config-panel .panel[data-v-7784b2d8]{background-color:rgba(255,255,255,0.95)\n}\n.lable-color-picker[data-v-7784b2d8]{list-style:none;margin:0px;padding:0px\n}\n.lable-color-picker li[data-v-7784b2d8]{display:inline-block;padding-right:15px\n}\n.lable-color-picker li p[data-v-7784b2d8]{font-size:12px;margin-top:7px;margin-left:2px;margin-bottom:0\n}\n.lable-selected-path-data[data-v-7784b2d8]{margin-top:-5px\n}\n.lable-selected-path-data p[data-v-7784b2d8]{font-size:12px;margin-bottom:0;margin-top:5px;word-wrap:break-word;word-break:break-all\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toRealPath */
/* unused harmony export toSVGPath */
/* harmony export (immutable) */ __webpack_exports__["a"] = toLabelData;
function toRealPath(path, width, height) {
  var realPath = [];
  path.forEach(function (percentage, index) {
    if (index % 2) {
      realPath.push(percentage * height);
    } else {
      realPath.push(percentage * width);
    }
  });
  return realPath;
}

function toSVGPath(path) {
  var SVGPath = [];
  path.forEach(function (n, index) {
    if (!index) {
      SVGPath.push('M');
    }
    if (index && index % 2 === 0) {
      SVGPath.push('L');
    }
    if (index % 2) {
      SVGPath.push(n);
    } else {
      SVGPath.push(n);
    }
  });
  SVGPath.push('z');
  return SVGPath.join(' ');
}

function toLabelData(data, width, height) {
  var products = [];
  // 遍历产品
  var productMap = {};
  // 遍历路径数据
  data.forEach(function (data) {
    data.product_number = data.alias || data.name;
    // 存在产品
    if (productMap[data.product_number]) {
      productMap[data.product_number].total++;
    } else {
      // 不存在产品创建一个未知产品
      productMap[data.product_number] = {
        name: data.product_number,
        number: data.product_number,
        image: 'https://slicejobsmisc.oss-cn-shanghai.aliyuncs.com/prod/imgr/product/zan-wu-tu-pian-0-20180424_160209_976990.png',
        total: 1
      };
      products.push(productMap[data.product_number]);
    }
    data.product = productMap[data.product_number];
    data.realPath = toRealPath(data.path, width, height);
    data.SVGPath = toSVGPath(data.realPath);
  });
  return {
    data: data,
    products: products,
    productMap: productMap,
    width: width,
    height: height
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = ({ toRealPath: toRealPath, toSVGPath: toSVGPath, toLabelData: toLabelData });

/***/ }),

/***/ 1721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isDestroy)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticStyle:{"position":"absolute","overflow":"hidden","left":"0","right":"0"}},[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.canvasData && _vm.canvasData.data.length),expression:"canvasData && canvasData.data.length"}],attrs:{"id":"canvas","width":_vm.width,"height":_vm.height}}),_vm._v(" "),(_vm.canvasData)?_c('div',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();},"pointerdown":function($event){$event.stopPropagation();$event.preventDefault();},"touchstart":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('div',{staticClass:"lable-config-panel"},[_c('layout-panel',{attrs:{"collapse":false}},[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("工具栏")]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("\n          图像识别ID:"+_vm._s(_vm.data.image_id)+"\n        ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('el-button',{attrs:{"type":"primary","size":"mini","disabled":!!this.data.is_exception,"loading":_vm.feedbackExceptionloading},on:{"click":_vm.onFeedbackException}},[(this.data.is_exception)?[_vm._v("已反馈识别异常")]:[_vm._v("识别异常反馈")]],2)],1),_vm._v(" "),_c('ul',{staticClass:"lable-color-picker",staticStyle:{"margin-top":"15px"}},[_c('li',[_c('el-color-picker',{attrs:{"show-alpha":"","size":"mini","predefine":_vm.predefineColors},on:{"change":_vm.onChangeColor},model:{value:(_vm.color.default.stroke),callback:function ($$v) {_vm.$set(_vm.color.default, "stroke", $$v)},expression:"color.default.stroke"}}),_vm._v(" "),_c('p',[_vm._v("默认")])],1),_vm._v(" "),_c('li',[_c('el-color-picker',{attrs:{"show-alpha":"","size":"mini","predefine":_vm.predefineColors},on:{"change":_vm.onChangeColor},model:{value:(_vm.color.hover.stroke),callback:function ($$v) {_vm.$set(_vm.color.hover, "stroke", $$v)},expression:"color.hover.stroke"}}),_vm._v(" "),_c('p',[_vm._v("悬浮")])],1),_vm._v(" "),_c('li',[_c('el-color-picker',{attrs:{"show-alpha":"","size":"mini","predefine":_vm.predefineColors},on:{"change":_vm.onChangeColor},model:{value:(_vm.color.active.stroke),callback:function ($$v) {_vm.$set(_vm.color.active, "stroke", $$v)},expression:"color.active.stroke"}}),_vm._v(" "),_c('p',[_vm._v("活跃")])],1)])])],1),_vm._v(" "),_c('div',{style:(("position: absolute;top: " + _vm.top + "px;left: " + _vm.left + "px;width: " + (_vm.canvasData.width) + "px; height: " + (_vm.canvasData.height) + "px;transform: rotate(" + _vm.angle + "deg) scale(" + _vm.scaleX + "," + _vm.scaleY + ");visibility: hidden;"))},[_c('el-popover',{attrs:{"placement":"bottom","title":_vm.selectedPathData.name,"width":"200","trigger":"manual"},model:{value:(_vm.popoverVisible),callback:function ($$v) {_vm.popoverVisible=$$v},expression:"popoverVisible"}},[_c('div',{staticClass:"lable-selected-path-data"},[_c('p',[_vm._v("标注ID："+_vm._s(_vm.selectedPathData.id))]),_vm._v(" "),_c('p',[_vm._v("产品编号："+_vm._s(_vm.selectedPathData.number))])]),_vm._v(" "),_c('div',{ref:"popover",staticStyle:{"position":"absolute"},attrs:{"slot":"reference"},slot:"reference"})])],1)]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawOverlayCanvas_vue__ = __webpack_require__(1580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d03a73d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawOverlayCanvas_vue__ = __webpack_require__(1726);
function injectStyle (ssrContext) {
  __webpack_require__(1723)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d03a73d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawOverlayCanvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d03a73d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawOverlayCanvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1723:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1724);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("11f5618d", content, true, {});

/***/ }),

/***/ 1724:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".draw-canvas[data-v-d03a73d8]{display:block}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/AnswerFileFullScreen/src/DrawOverlayCanvas.vue"],"names":[],"mappings":"AACA,8BAA8B,aAAa,CAC1C","file":"DrawOverlayCanvas.vue","sourcesContent":["\n.draw-canvas[data-v-d03a73d8]{display:block\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1725:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createArrowHeadSegments;
function createArrowHeadSegments(start, end) {
  var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 18;
  var angle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.PI / 7;

  var theta = Math.atan2(end.y - start.y, end.x - start.x);
  var tip = { x: end.x, y: end.y };
  var left = {
    x: end.x - length * Math.cos(theta + angle),
    y: end.y - length * Math.sin(theta + angle)
  };
  var right = {
    x: end.x - length * Math.cos(theta - angle),
    y: end.y - length * Math.sin(theta - angle)
  };

  return [[tip, left], [tip, right]];
}

/***/ }),

/***/ 1726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"drawCanvas",staticClass:"draw-canvas"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1727:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawToolbar_vue__ = __webpack_require__(1581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059322d7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawToolbar_vue__ = __webpack_require__(1730);
function injectStyle (ssrContext) {
  __webpack_require__(1728)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-059322d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawToolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059322d7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawToolbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1728:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1729);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1eed4d8b", content, true, {});

/***/ }),

/***/ 1729:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".draw-toolbar-vertical[data-v-059322d7]{-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;left:16px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);max-height:calc(100% - 24px);overflow-x:hidden;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none;z-index:40;pointer-events:auto}.draw-toolbar-vertical[data-v-059322d7]::-webkit-scrollbar{width:0;height:0;display:none}.draw-toolbar-vertical ul[data-v-059322d7]{list-style:none;margin:0;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:12px;background-color:rgba(0,0,0,.62);border:1px solid hsla(0,0%,100%,.08);border-radius:8px;padding:14px 12px}.draw-toolbar-vertical li[data-v-059322d7],.draw-toolbar-vertical ul[data-v-059322d7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.draw-toolbar-vertical li[data-v-059322d7]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0}.draw-toolbar-vertical[data-v-059322d7] .el-color-picker{display:block;line-height:0}.draw-toolbar-vertical[data-v-059322d7] .el-color-picker__trigger{margin:0 auto}.draw-toolbar-vertical .paint-icon[data-v-059322d7]{width:22px;height:22px;vertical-align:middle;color:currentColor}.draw-toolbar-vertical .paint-icon ellipse[data-v-059322d7],.draw-toolbar-vertical .paint-icon path[data-v-059322d7],.draw-toolbar-vertical .paint-icon rect[data-v-059322d7]{fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round}.draw-toolbar-vertical .el-button.is-disabled .paint-icon[data-v-059322d7]{opacity:.35}.draw-toolbar-vertical [class*=\" sj-icon-\"][data-v-059322d7],.draw-toolbar-vertical [class^=sj-icon-][data-v-059322d7]{color:currentColor;display:inline-block;font-size:22px;line-height:22px;vertical-align:middle}.draw-toolbar-vertical[data-v-059322d7] .el-button{padding:10px;color:hsla(0,0%,100%,.72);background-color:transparent}.draw-toolbar-vertical[data-v-059322d7] .el-button:hover{color:hsla(0,0%,100%,.9)}.draw-toolbar-vertical[data-v-059322d7] .el-button.is-disabled{color:hsla(0,0%,100%,.35)}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/AnswerFileFullScreen/src/DrawToolbar.vue"],"names":[],"mappings":"AACA,wCAAwC,8BAA8B,sBAAsB,kBAAkB,UAAU,QAAQ,mCAAmC,2BAA2B,6BAA6B,kBAAkB,gBAAgB,qBAAqB,wBAAwB,WAAW,mBAAmB,CACvU,AACD,2DAA2D,QAAQ,SAAS,YAAY,CACvF,AACD,2CAA2C,gBAAgB,SAAS,AAAqD,4BAA4B,6BAA6B,0BAA0B,sBAAsB,AAAkE,SAAS,iCAAkC,qCAAwC,kBAAkB,iBAAiB,CACzZ,AACD,sFAFoE,oBAAoB,oBAAoB,aAAa,AAAyG,yBAAyB,sBAAsB,kBAAmB,CAGnS,AADD,2CAAkK,wBAAwB,qBAAqB,uBAAuB,SAAS,CAC9O,AACD,yDAAyD,cAAc,aAAa,CACnF,AACD,kEAAkE,aAAa,CAC9E,AACD,oDAAoD,WAAW,YAAY,sBAAsB,kBAAkB,CAClH,AACD,8KAA8K,UAAU,oBAAoB,iBAAiB,qBAAqB,qBAAqB,CACtQ,AACD,2EAA2E,WAAY,CACtF,AACD,uHAAyH,mBAAmB,qBAAqB,eAAe,iBAAiB,qBAAqB,CACrN,AACD,mDAAmD,aAAa,0BAA6B,4BAA4B,CACxH,AACD,yDAAyD,wBAA2B,CACnF,AACD,+DAA+D,yBAA4B,CAC1F","file":"DrawToolbar.vue","sourcesContent":["\n.draw-toolbar-vertical[data-v-059322d7]{-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;left:16px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);max-height:calc(100% - 24px);overflow-x:hidden;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none;z-index:40;pointer-events:auto\n}\n.draw-toolbar-vertical[data-v-059322d7]::-webkit-scrollbar{width:0;height:0;display:none\n}\n.draw-toolbar-vertical ul[data-v-059322d7]{list-style:none;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;background-color:rgba(0,0,0,0.62);border:1px solid rgba(255,255,255,0.08);border-radius:8px;padding:14px 12px\n}\n.draw-toolbar-vertical li[data-v-059322d7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0\n}\n.draw-toolbar-vertical[data-v-059322d7] .el-color-picker{display:block;line-height:0\n}\n.draw-toolbar-vertical[data-v-059322d7] .el-color-picker__trigger{margin:0 auto\n}\n.draw-toolbar-vertical .paint-icon[data-v-059322d7]{width:22px;height:22px;vertical-align:middle;color:currentColor\n}\n.draw-toolbar-vertical .paint-icon path[data-v-059322d7],.draw-toolbar-vertical .paint-icon rect[data-v-059322d7],.draw-toolbar-vertical .paint-icon ellipse[data-v-059322d7]{fill:none;stroke:currentColor;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round\n}\n.draw-toolbar-vertical .el-button.is-disabled .paint-icon[data-v-059322d7]{opacity:0.35\n}\n.draw-toolbar-vertical [class*=\" sj-icon-\"][data-v-059322d7],.draw-toolbar-vertical [class^=\"sj-icon-\"][data-v-059322d7]{color:currentColor;display:inline-block;font-size:22px;line-height:22px;vertical-align:middle\n}\n.draw-toolbar-vertical[data-v-059322d7] .el-button{padding:10px;color:rgba(255,255,255,0.72);background-color:transparent\n}\n.draw-toolbar-vertical[data-v-059322d7] .el-button:hover{color:rgba(255,255,255,0.9)\n}\n.draw-toolbar-vertical[data-v-059322d7] .el-button.is-disabled{color:rgba(255,255,255,0.35)\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1730:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draw-toolbar-vertical"},[_c('ul',[_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"矩形"},on:{"click":function($event){return _vm.$emit('tool-change', 'rect')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('rect',{attrs:{"x":"6","y":"6","width":"12","height":"12","rx":"2","ry":"2"}})])])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"椭圆（Shift 画圆）"},on:{"click":function($event){return _vm.$emit('tool-change', 'ellipse')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('ellipse',{attrs:{"cx":"12","cy":"12","rx":"7","ry":"4.5"}})])])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"自由绘画"},on:{"click":function($event){return _vm.$emit('tool-change', 'free')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M3 17.25V21h3.75L18.81 8.94l-3.75-3.75L3 17.25z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.06 5.19l3.75 3.75"}})])])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"文字"},on:{"click":function($event){return _vm.$emit('tool-change', 'text')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M5 6h14v2h-6v12h-2V8H5z"}})])])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"箭头"},on:{"click":function($event){return _vm.$emit('tool-change', 'arrow')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M4 20L20 4"}}),_vm._v(" "),_c('path',{attrs:{"d":"M12 4h8v8"}})])])],1),_vm._v(" "),_c('li',[_c('el-color-picker',{attrs:{"size":"mini","predefine":_vm.predefineColors,"title":"标注颜色"},on:{"change":_vm.onStrokeChange},model:{value:(_vm.localStroke),callback:function ($$v) {_vm.localStroke=$$v},expression:"localStroke"}})],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving || !_vm.drawCanUndo,"title":"撤销"},on:{"click":function($event){return _vm.$emit('undo')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M9 7L4 12l5 5"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4 12h12"}})])])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving || !_vm.drawCanRedo,"title":"重做"},on:{"click":function($event){return _vm.$emit('redo')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M15 7l5 5-5 5"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4 12h16"}})])])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"左旋转"},on:{"click":function($event){return _vm.$emit('rotate', -90)}}},[_c('span',{staticClass:"sj-icon-rotate-left"})])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"右旋转"},on:{"click":function($event){return _vm.$emit('rotate', 90)}}},[_c('span',{staticClass:"sj-icon-rotate-right"})])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","disabled":_vm.drawSaving,"title":"取消"},on:{"click":function($event){return _vm.$emit('cancel')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M18 6L6 18"}}),_vm._v(" "),_c('path',{attrs:{"d":"M6 6l12 12"}})])])],1),_vm._v(" "),_c('li',[_c('el-button',{attrs:{"type":"text","size":"small","loading":_vm.drawSaving,"title":"保存"},on:{"click":function($event){return _vm.$emit('save')}}},[_c('svg',{staticClass:"paint-icon",attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M20 6L9 17l-5-5"}})])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"view-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.drawMode),expression:"drawMode"}],ref:"drawOverlayWrap",staticClass:"draw-overlay-wrap",style:(_vm.drawOverlayStyle)},[_c('draw-overlay-canvas',{ref:"drawOverlay",attrs:{"visible":_vm.drawMode,"width":_vm.drawOverlayCanvasWidth,"height":_vm.drawOverlayCanvasHeight,"rotation":_vm.drawRotation,"tool":_vm.drawTool,"stroke":_vm.drawStroke,"stroke-width":_vm.drawStrokeWidth},on:{"history-change":_vm.onHistoryChange}})],1),_vm._v(" "),(_vm.drawMode)?_c('draw-toolbar',{attrs:{"draw-saving":_vm.drawSaving,"draw-can-undo":_vm.drawCanUndo,"draw-can-redo":_vm.drawCanRedo,"stroke":_vm.drawStroke},on:{"undo":_vm.onUndo,"redo":_vm.onRedo,"tool-change":_vm.setDrawTool,"rotate":_vm.onDrawRotate,"save":_vm.onDrawSave,"cancel":_vm.onDrawCancel,"stroke-change":_vm.onStrokeChange}}):_vm._e(),_vm._v(" "),(_vm.preIndex !== null)?_c('img',{ref:"image",staticStyle:{"display":"none"},attrs:{"src":_vm._f("ossHost")(_vm.preSrc,_vm.autoOrientSuffix)},on:{"load":_vm.nextPreIndex}}):_vm._e(),_vm._v(" "),_c('ul',{ref:"images",staticStyle:{"display":"none"}},_vm._l((_vm.files),function(ref,index){
var src = ref.src;
return _c('li',{key:index+src},[_c('img',{attrs:{"src":_vm._f("ossHost")(src,_vm.suffix),"alt":src.replace(/^.*\//, '').replace(/[?&#].*$/, '')}})])}),0)],1),_vm._v(" "),(!_vm.drawMode)?_c('div',{staticClass:"view-toolbar"},[_c('ul',[_c('li',{staticClass:"draw-entry",class:{ 'draw-disabled': !_vm.showDrawButton },on:{"click":function($event){return _vm.enterDrawMode()}}},[_vm._m(0)]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.zoomIn),expression:"lastToolbar.zoomIn"}],on:{"click":function($event){return _vm.onZoom(0.1)}}},[_c('span',{staticClass:"sj-icon-enlarge"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.zoomOut),expression:"lastToolbar.zoomOut"}],on:{"click":function($event){return _vm.onZoom(-0.1)}}},[_c('span',{staticClass:"sj-icon-shrink"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.oneToOne),expression:"lastToolbar.oneToOne"}],on:{"click":function($event){return _vm.onOneToOne()}}},[_c('span',{staticClass:"sj-icon-one-to-one"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.prev),expression:"lastToolbar.prev"}],on:{"click":function($event){return _vm.onPrev()}}},[_c('span',{staticClass:"el-icon-caret-left"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.next),expression:"lastToolbar.next"}],on:{"click":function($event){return _vm.onNext()}}},[_c('span',{staticClass:"el-icon-caret-right"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.reset),expression:"lastToolbar.reset"}],on:{"click":function($event){return _vm.onReset()}}},[_c('span',{staticClass:"el-icon-refresh"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.rotateLeft),expression:"lastToolbar.rotateLeft"}],on:{"click":function($event){return _vm.onRotate(-90)}}},[_c('span',{staticClass:"sj-icon-rotate-left"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.rotateRight),expression:"lastToolbar.rotateRight"}],on:{"click":function($event){return _vm.onRotate(90)}}},[_c('span',{staticClass:"sj-icon-rotate-right"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.delete),expression:"lastToolbar.delete"}],on:{"click":function($event){return _vm.onDelete()}}},[_c('span',{staticClass:"el-icon-delete"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.download),expression:"lastToolbar.download"}],on:{"click":function($event){return _vm.onDownload()}}},[_c('span',{staticClass:"el-icon-download"})])])]):_vm._e(),_vm._v(" "),(!_vm.drawMode)?_c('div',{staticClass:"view-toolbar-bottom"},[_c('ul',[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.zoomIn),expression:"lastToolbar.zoomIn"}],on:{"click":function($event){return _vm.onZoom(0.1)}}},[_c('span',{staticClass:"sj-icon-enlarge"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.zoomOut),expression:"lastToolbar.zoomOut"}],on:{"click":function($event){return _vm.onZoom(-0.1)}}},[_c('span',{staticClass:"sj-icon-shrink"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.oneToOne),expression:"lastToolbar.oneToOne"}],on:{"click":function($event){return _vm.onOneToOne()}}},[_c('span',{staticClass:"sj-icon-one-to-one"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.prev),expression:"lastToolbar.prev"}],on:{"click":function($event){return _vm.onPrev()}}},[_c('span',{staticClass:"el-icon-caret-left"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.next),expression:"lastToolbar.next"}],on:{"click":function($event){return _vm.onNext()}}},[_c('span',{staticClass:"el-icon-caret-right"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.reset),expression:"lastToolbar.reset"}],on:{"click":function($event){return _vm.onReset()}}},[_c('span',{staticClass:"el-icon-refresh"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.rotateLeft),expression:"lastToolbar.rotateLeft"}],on:{"click":function($event){return _vm.onRotate(-90)}}},[_c('span',{staticClass:"sj-icon-rotate-left"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.rotateRight),expression:"lastToolbar.rotateRight"}],on:{"click":function($event){return _vm.onRotate(90)}}},[_c('span',{staticClass:"sj-icon-rotate-right"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.delete),expression:"lastToolbar.delete"}],on:{"click":function($event){return _vm.onDelete()}}},[_c('span',{staticClass:"el-icon-delete"})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastToolbar.download),expression:"lastToolbar.download"}],on:{"click":function($event){return _vm.onDownload()}}},[_c('span',{staticClass:"el-icon-download"})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"view-navbar"},[_c('ul',{ref:"view-list",staticClass:"clear-both",style:({width:(_vm.ulWidth + "px"), transform: ("translateX(" + _vm.ulTransform + "px)"), pointerEvents: _vm.drawMode ? 'none' : 'auto'})},_vm._l((_vm.files),function(ref,index){
var src = ref.src;
return _c('li',{key:index+src,class:_vm.viewIndex===index?'active':'',on:{"click":function($event){return _vm.view(index)}}},[_c('img',{attrs:{"src":_vm._f("ossHost")(src,_vm.suffix),"alt":src}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"view-footer-badge"},[_c('div',[_vm._v(_vm._s(_vm.viewIndex + 1)+"/"+_vm._s(_vm.files.length))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"draw-entry-text"},[_vm._v("图片"),_c('br'),_vm._v("标注")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1739:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".question-review .panel-body{overflow:hidden}.question-review .question-panel{margin-bottom:30px}.question-review .question-panel:last-child{margin-bottom:0}.question-review .question-panel.jump{opacity:.6}.question-review .question-panel .panel{margin:0}.question-review .question-panel .panel-body{padding-top:0}.question-review .question-panel .panel-heading{padding:10px 15px}.question-review .question-panel .panel-heading .tools{margin:-5px -8px}.question-review .question-panel .panel-heading .tools button{background-color:transparent;min-height:26px;min-width:26px;padding:0}.question-review .question-panel .panel-heading .tools button:hover{background-color:#7195cc}.question-review .question-panel .question-title{margin-top:15px}.question-review .question-panel .question-title .question-title-text{font-size:14px;color:#303133}.question-review .answer--file{margin-top:15px;padding:10px;background:#f9fafc;overflow:hidden;border:1px solid #3f9fff;border-radius:4px}.question-review .file-list .empty-text{font-size:13px;color:#c0c4cc;cursor:not-allowed}.question-review .file-list ul{margin:0;padding:0;list-style-type:none}.question-review .file-list ul li{float:left;cursor:pointer;margin:10px}.question-review .file-list ul li .answer-file-icon{width:75px;height:75px;font-size:40px;line-height:75px;text-align:center;color:#606266;background-color:#fff}.question-review .file-list ul li.file-separate-line{border-right:1px dashed #dcdfe6;height:75px}.question-review .file-list ul:after{clear:both}.question-review .question-detail{display:flex;margin-top:15px;margin-right:-20px}.question-review .question-detail .question-detail-title{font-weight:700;color:#409eff}.question-review .question-detail .question-detail-img ul{margin:0;padding:0;list-style-type:none}.question-review .question-detail .question-detail-img ul li{float:left;cursor:pointer;margin:5px}.question-review .question-detail .question-detail-img ul li img{display:block;width:75px;height:75px}.question-review .question-detail .question-detail-img ul:after{clear:both}.question-review .question-detail .question-detail-img,.question-review .question-detail .question-detail-text{padding:10px;background:#f9fafc;overflow:hidden;color:#303133;line-height:1.5;height:85px;border-radius:4px;font-size:13px}.question-review .answer-title{margin-top:15px;font-size:14px;color:#606266}.question-review .answer--text--input{margin-top:15px}.question-review .answer--text--input .el-textarea__inner{border:1px solid #3f9fff;background:#f9fafc}.question-review .answer--review{margin-top:15px}.question-review .answer--review .answer-error-message{color:#909399;padding:10px;font-size:14px}.question-review .answer--review button.is-plain{background-color:#fff}.question-review .answer--review .el-button--danger{width:100px}.question-review .answer--review .el-button--danger.is-plain:focus,.question-review .answer--review .el-button--danger.is-plain:hover{background:#f56c6c;border-color:#f56c6c;color:#fff}.question-review .answer--review .el-button--success{width:100px}.question-review .answer--review .el-button--success.is-plain:focus,.question-review .answer--review .el-button--success.is-plain:hover{background:#67c23a;border-color:#67c23a;color:#fff}.question-review .question-options{margin-top:20px;margin-bottom:20px}.question-review .question-options .question--option{font-size:14px;margin-top:10px;margin-bottom:10px;color:#606266}.question-review .question-options .question--option>span{cursor:pointer}.question-review .question-options .question--option>span:hover{color:#67c23a}.question-review .question-options .question--option.disabled>span{cursor:not-allowed}.question-review .question-options .question--option.disabled>span:hover{color:inherit}.question-review .question-options .question--option.selected{color:#67c23a}.question-review .question-options .question--option i[class^=sj-icon],.question-review .question-options .question--option i span{font-weight:700}.question-review .question-options .question--option .option-title,.question-review .question-options .question--option i,.question-review .question-options .question--option img{vertical-align:middle}.question-review .question-options .question--option i span{display:inline-block;padding-left:5px;min-width:50px}.question-review .question-options .question--option img{display:inline-block;width:40px;height:40px}.question-review .question-options .question--option .option-title{padding-left:5px}.question-review .question-options .multitext-options{width:100%;margin-top:15px}.question-number .el-tag{position:relative;min-width:28px;text-align:center;padding:0 4px;margin-right:5px;margin-bottom:10px;cursor:pointer;color:#606266}.question-number .el-tag .badge{position:absolute;bottom:-6px;left:12px;height:3px;width:3px;border-radius:50%}.question-number .el-tag .badge.success{background-color:#67c23a}.question-number .el-tag .badge.danger{background-color:#f56c6c}.question-number .el-tag:hover{opacity:.8}.question-number .el-tag--success{background-color:#67c23a;border-color:transparent;color:#fff}.question-number .el-tag--danger{background-color:#f56c6c;border-color:transparent;color:#fff}.question-number .el-tag--info{border-color:transparent;background-color:rgba(48,49,51,.1)}.question-number .el-tag--warning{background-color:transparent;border-color:transparent;color:#909399}.question-review-msg-box{width:600px}.question-review-msg-box .el-dialog__body{padding-top:15px}.question-review-msg-box .msg-list{display:flex;margin-bottom:20px}.question-review-msg-box .msg-list .el-radio{display:block;margin-left:0;margin-bottom:5px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.question-review-msg-box .question-detail-img ul{margin:0;padding:0;overflow-x:scroll;overflow-y:hidden;white-space:nowrap;list-style-type:none}.question-review-msg-box .question-detail-img ul li{display:inline-block;cursor:pointer;margin:5px;position:relative}.question-review-msg-box .question-detail-img ul li img{display:block;width:70px;height:70px}.question-review-msg-box .question-detail-img ul li i.selected-mark{font-size:25px;background:#fff;border-radius:50%;position:absolute;top:0;right:0}.question-review-msg-box .question-detail-img ul:after{clear:both}.question-review-msg-box .question-detail-img{padding:10px 10px 0;background:#f9fafc;color:#303133;line-height:1.5;height:95px;border-radius:4px;font-size:13px}.task-review-evidence-dialog{overflow:visible!important}.task-review-evidence-dialog .viewer-backdrop{background-color:transparent}.task-review-evidence-dialog .el-dialog__header{padding:10px}.task-review-evidence-dialog .el-dialog__header .el-dialog__title{line-height:20px;font-size:16px}.task-review-evidence-dialog .el-dialog__headerbtn{top:10px;right:10px;font-size:16px}.task-review-evidence-dialog .el-dialog__body{box-sizing:border-box;height:calc(100% - 41px);padding:0}.task-review-evidence-dialog .tred-container{display:flex;height:100%}.task-review-evidence-dialog .tred-container-left{width:calc(100% - 270px);position:relative}.task-review-evidence-dialog .tred-container-right{padding-left:10px;padding-right:10px;width:250px;overflow:hidden}.task-review-evidence-dialog.dark{background-color:rgba(26,26,26,.95)!important}.task-review-evidence-dialog.dark .el-dialog__close,.task-review-evidence-dialog.dark .el-dialog__title{color:#ddd}.task-review-evidence-dialog.dark .tred-container-right{background-color:hsla(0,0%,100%,.95);border-radius:3px}.task-review-evidence-dialog.dark .el-collapse-item__header,.task-review-evidence-dialog.dark .el-collapse-item__wrap{border-bottom:1px solid transparent;background-color:transparent}.task-review-evidence-dialog.lighter{background-color:hsla(0,0%,100%,.95)!important}.task-review-evidence-dialog.lighter .tred-container-right{background-color:transparent}.task-review-evidence-dialog.lighter .el-collapse-item__header,.task-review-evidence-dialog.lighter .el-collapse-item__wrap{border-bottom:1px solid transparent;background-color:transparent}", "", {"version":3,"sources":["/workspace/src/views/question-review/src/views/question-review/question-review.scss"],"names":[],"mappings":"AAAA,6BAEI,eAAgB,CAFpB,iCAMI,kBAAmB,CANvB,4CASM,eAAgB,CATtB,sCAaM,UAAW,CAbjB,wCAiBM,QAAW,CAjBjB,6CAqBM,aAAgB,CArBtB,gDAyBM,iBAAkB,CAzBxB,uDA4BQ,gBAAiB,CA5BzB,8DA+BU,6BACA,gBACA,eACA,SAAY,CAlCtB,oEAqCY,wBAAyB,CArCrC,iDA4CM,eAAgB,CA5CtB,sEA+CQ,eACA,aAAc,CAhDtB,+BAyDI,gBACA,aACA,mBACA,gBACA,yBACA,iBAAkB,CA9DtB,wCAqEM,eACA,cACA,kBAAmB,CAvEzB,+BA2EM,SACA,UACA,oBAAqB,CA7E3B,kCAgFQ,WACA,eACA,WAAY,CAlFpB,oDAqFU,WACA,YACA,eACA,iBACA,kBACA,cACA,qBAAsB,CA3FhC,qDA+FU,gCACA,WA/BO,CAjEjB,qCAqGQ,UAAW,CArGnB,kCA8GI,aACA,gBACA,kBAAmB,CAhHvB,yDAmHM,gBACA,aAAc,CApHpB,0DAyHQ,SACA,UACA,oBAAqB,CA3H7B,6DA8HU,WACA,eACA,UAAW,CAhIrB,iEAmIY,cACA,WACA,WApEK,CAjEjB,gEA0IU,UAAW,CA1IrB,+GAiJM,aACA,mBACA,gBACA,cACA,gBACA,YACA,kBACA,cAAe,CAxJrB,+BAgKI,gBACA,eACA,aAAc,CAlKlB,sCAsKI,eAAgB,CAtKpB,0DAyKM,yBACA,kBAAmB,CA1KzB,iCA+KI,eAAgB,CA/KpB,uDAkLM,cACA,aACA,cAAe,CApLrB,iDAwLM,qBAAsB,CAxL5B,oDA4LM,WAAY,CA5LlB,sIAgMQ,mBACA,qBACA,UAAW,CAlMnB,qDAuMM,WAAY,CAvMlB,wIA2MQ,mBACA,qBACA,UAAW,CA7MnB,mCAsNI,gBACA,kBAAmB,CAvNvB,qDA0NM,eACA,gBACA,mBACA,aAAc,CA7NpB,0DAgOQ,cAAe,CAhOvB,gEAmOU,aAAc,CAnOxB,mEAwOQ,kBAAmB,CAxO3B,yEA2OU,aAAc,CA3OxB,8DAgPQ,aAAc,CAhPtB,mIAoPQ,eAAgB,CApPxB,mLAwPQ,qBAAsB,CAxP9B,4DA4PQ,qBACA,iBACA,cAAe,CA9PvB,yDAkQQ,qBACA,WACA,WAAY,CApQpB,mEAwQQ,gBAAiB,CAxQzB,sDA6QM,WACA,eAAgB,CACjB,yBAOD,kBACA,eACA,kBACA,cACA,iBACA,mBACA,eACA,aAAc,CATlB,gCAYM,kBACA,YACA,UACA,WACA,UACA,iBAAkB,CAjBxB,wCAoBQ,wBAAyB,CApBjC,uCAwBQ,wBAAyB,CAxBjC,+BA6BM,UAAW,CA7BjB,kCAkCI,yBACA,yBACA,UAAY,CApChB,iCAwCI,yBACA,yBACA,UAAY,CA1ChB,+BA8CI,yBACA,kCAAuC,CA/C3C,kCAmDI,6BACA,yBACA,aAAc,CACf,yBAQD,WAAY,CADd,0CAKI,gBAAiB,CALrB,mCASI,aACA,kBAAmB,CAVvB,6CAaM,cACA,cACA,kBAEA,uBACA,mBACA,eAAgB,CAnBtB,iDAwBM,SACA,UACA,kBACA,kBACA,mBACA,oBAAqB,CA7B3B,oDAgCQ,qBACA,eACA,WACA,iBAAkB,CAnC1B,wDAsCU,cACA,WACA,WAtCO,CAFjB,oEA4CU,eACA,gBACA,kBACA,kBACA,MACA,OAAQ,CAjDlB,uDAsDQ,UAAW,CAtDnB,8CA2DI,oBACA,mBACA,cACA,gBACA,YACA,kBACA,cAAe,CAChB,6BAMD,0BAA4B,CAH9B,8CAMI,4BAA6B,CANjC,gDAUI,YAAa,CAVjB,kEAaM,iBACA,cAAe,CAdrB,mDAmBI,SACA,WACA,cAAe,CArBnB,8CAyBI,sBACA,yBACA,SAAY,CA3BhB,6CA+BI,aACA,WAAY,CAhChB,kDAmCM,yBACA,iBAAkB,CApCxB,mDAwCM,kBACA,mBACA,YACA,eAAgB,CACjB,kCAKH,6CAAkD,CADpD,wGAII,UAAW,CAJf,wDAQI,qCACA,iBAAkB,CATtB,sHAaI,oCAAoC,AAIpC,4BAA6B,CAjBjC,AAkBG,qCAID,8CAAsD,CADxD,2DAII,4BAA6B,CAJjC,4HAQI,oCAAoC,AAIpC,4BAA6B,CAZjC","file":"question-review.scss","sourcesContent":[".question-review {\n  .panel-body {\n    overflow: hidden;\n  }\n\n  .question-panel {\n    margin-bottom: 30px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    &.jump {\n      opacity: .6;\n    }\n\n    .panel {\n      margin: 0px;\n    }\n\n    .panel-body {\n      padding-top: 0px;\n    }\n\n    .panel-heading {\n      padding: 10px 15px;\n\n      .tools {\n        margin: -5px -8px;\n\n        button {\n          background-color: transparent;\n          min-height: 26px;\n          min-width: 26px;\n          padding: 0px;\n\n          &:hover {\n            background-color: #7195cc;\n          }\n        }\n      }\n    }\n\n    .question-title {\n      margin-top: 15px;\n\n      .question-title-text {\n        font-size: 14px;\n        color: #303133;\n      }\n    }\n  }\n\n  /**\n   * 答案的文件列表\n   */\n  .answer--file {\n    margin-top: 15px;\n    padding: 10px;\n    background: #f9fafc;\n    overflow: hidden;\n    border: 1px solid #3f9fff;\n    border-radius: 4px;\n  }\n\n  $img-size: 75px;\n\n  .file-list {\n    .empty-text {\n      font-size: 13px;\n      color: #c0c4cc;\n      cursor: not-allowed;\n    }\n\n    ul {\n      margin: 0;\n      padding: 0;\n      list-style-type: none;\n\n      li {\n        float: left;\n        cursor: pointer;\n        margin: 10px;\n\n        .answer-file-icon {\n          width: $img-size;\n          height: $img-size;\n          font-size: 40px;\n          line-height: $img-size;\n          text-align: center;\n          color: #606266;\n          background-color: #fff;\n        }\n\n        &.file-separate-line {\n          border-right: 1px dashed #DCDFE6;\n          height: $img-size;\n        }\n      }\n\n      &:after {\n        clear: both;\n      }\n    }\n  }\n\n  /**\n   * 问题的详情列表\n   */\n  .question-detail {\n    display: flex;\n    margin-top: 15px;\n    margin-right: -20px;\n\n    .question-detail-title {\n      font-weight: 700;\n      color: #409eff;\n    }\n\n    .question-detail-img {\n      ul {\n        margin: 0px;\n        padding: 0px;\n        list-style-type: none;\n\n        li {\n          float: left;\n          cursor: pointer;\n          margin: 5px;\n\n          img {\n            display: block;\n            width: $img-size;\n            height: $img-size;\n          }\n        }\n\n        &:after {\n          clear: both;\n        }\n      }\n    }\n\n    .question-detail-text,\n    .question-detail-img {\n      padding: 10px;\n      background: #f9fafc;\n      overflow: hidden;\n      color: #303133;\n      line-height: 1.5;\n      height: 85px;\n      border-radius: 4px;\n      font-size: 13px;\n    }\n  }\n\n  /**\n   * 答案\n   */\n  .answer-title {\n    margin-top: 15px;\n    font-size: 14px;\n    color: #606266;\n  }\n\n  .answer--text--input {\n    margin-top: 15px;\n\n    .el-textarea__inner {\n      border: 1px solid #3f9fff;\n      background: #f9fafc;\n    }\n  }\n\n  .answer--review {\n    margin-top: 15px;\n\n    .answer-error-message {\n      color: #909399;\n      padding: 10px;\n      font-size: 14px;\n    }\n\n    button.is-plain {\n      background-color: #fff;\n    }\n\n    .el-button--danger {\n      width: 100px;\n\n      &.is-plain:focus,\n      &.is-plain:hover {\n        background: #f56c6c;\n        border-color: #f56c6c;\n        color: #fff;\n      }\n    }\n\n    .el-button--success {\n      width: 100px;\n\n      &.is-plain:focus,\n      &.is-plain:hover {\n        background: #67c23a;\n        border-color: #67c23a;\n        color: #fff;\n      }\n    }\n  }\n\n  /**\n   * 选项\n   */\n  .question-options {\n    margin-top: 20px;\n    margin-bottom: 20px;\n\n    .question--option {\n      font-size: 14px;\n      margin-top: 10px;\n      margin-bottom: 10px;\n      color: #606266;\n\n      & > span {\n        cursor: pointer;\n\n        &:hover {\n          color: #67c23a;\n        }\n      }\n\n      &.disabled > span {\n        cursor: not-allowed;\n\n        &:hover {\n          color: inherit;\n        }\n      }\n\n      &.selected {\n        color: #67c23a;\n      }\n\n      i[class^=\"sj-icon\"], i span {\n        font-weight: 700;\n      }\n\n      i, img, .option-title {\n        vertical-align: middle;\n      }\n\n      i span {\n        display: inline-block;\n        padding-left: 5px;\n        min-width: 50px;\n      }\n\n      img {\n        display: inline-block;\n        width: 40px;\n        height: 40px;\n      }\n\n      .option-title {\n        padding-left: 5px;\n      }\n    }\n\n    .multitext-options {\n      width: 100%;\n      margin-top: 15px;\n    }\n  }\n\n}\n\n.question-number {\n  .el-tag {\n    position: relative;\n    min-width: 28px;\n    text-align: center;\n    padding: 0 4px;\n    margin-right: 5px;\n    margin-bottom: 10px;\n    cursor: pointer;\n    color: #606266;\n\n    .badge {\n      position: absolute;\n      bottom: -6px;\n      left: 12px;\n      height: 3px;\n      width: 3px;\n      border-radius: 50%;\n\n      &.success {\n        background-color: #67c23a;\n      }\n\n      &.danger {\n        background-color: #f56c6c;\n      }\n    }\n\n    &:hover {\n      opacity: .8;\n    }\n  }\n\n  .el-tag--success {\n    background-color: #67c23a;\n    border-color: transparent;\n    color: white;\n  }\n\n  .el-tag--danger {\n    background-color: #f56c6c;\n    border-color: transparent;\n    color: white;\n  }\n\n  .el-tag--info {\n    border-color: transparent;\n    background-color: rgba(48, 49, 51, 0.1);\n  }\n\n  .el-tag--warning {\n    background-color: transparent;\n    border-color: transparent;\n    color: #909399;\n  }\n}\n\n/**\n * 不通过弹框\n */\n\n.question-review-msg-box {\n  width: 600px;\n  $img-size: 70px;\n\n  .el-dialog__body {\n    padding-top: 15px;\n  }\n\n  .msg-list {\n    display: flex;\n    margin-bottom: 20px;\n\n    .el-radio {\n      display: block;\n      margin-left: 0;\n      margin-bottom: 5px;\n      // 超长显示省略号\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n  .question-detail-img {\n    ul {\n      margin: 0;\n      padding: 0;\n      overflow-x: scroll;\n      overflow-y: hidden;\n      white-space: nowrap;\n      list-style-type: none;\n\n      li {\n        display: inline-block;\n        cursor: pointer;\n        margin: 5px;\n        position: relative;\n\n        img {\n          display: block;\n          width: $img-size;\n          height: $img-size;\n        }\n\n        i.selected-mark {\n          font-size: 25px;\n          background: #fff;\n          border-radius: 50%;\n          position: absolute;\n          top: 0;\n          right: 0;\n        }\n      }\n\n      &:after {\n        clear: both;\n      }\n    }\n  }\n  .question-detail-img {\n    padding: 10px 10px 0 10px;\n    background: #f9fafc;\n    color: #303133;\n    line-height: 1.5;\n    height: 95px;\n    border-radius: 4px;\n    font-size: 13px;\n  }\n}\n\n.task-review-evidence-dialog {\n  // todo 视频播放会因为这个属性为 auto 时无法播放，\n  //  目前仅mac chrome 有此现象，可能为浏览器bug，待后续跟进\n  overflow: visible !important;\n\n  .viewer-backdrop {\n    background-color: transparent;\n  }\n\n  .el-dialog__header {\n    padding: 10px;\n\n    .el-dialog__title {\n      line-height: 20px;\n      font-size: 16px;\n    }\n  }\n\n  .el-dialog__headerbtn {\n    top: 10px;\n    right: 10px;\n    font-size: 16px;\n  }\n\n  .el-dialog__body {\n    box-sizing: border-box;\n    height: calc(100% - 41px);\n    padding: 0px;\n  }\n\n  .tred-container {\n    display: flex;\n    height: 100%;\n\n    &-left {\n      width: calc(100% - 270px);\n      position: relative;\n    }\n\n    &-right {\n      padding-left: 10px;\n      padding-right: 10px;\n      width: 250px;\n      overflow: hidden;\n    }\n  }\n}\n\n.task-review-evidence-dialog.dark {\n  background-color: rgba(26, 26, 26, .95) !important;\n\n  .el-dialog__title, .el-dialog__close {\n    color: #ddd;\n  }\n\n  .tred-container-right {\n    background-color: rgba(255, 255, 255, 0.95);\n    border-radius: 3px;\n  }\n\n  .el-collapse-item__header, .el-collapse-item__wrap {\n    border-bottom: 1px solid transparent;\n  }\n\n  .el-collapse-item__header, .el-collapse-item__wrap {\n    background-color: transparent;\n  }\n}\n\n.task-review-evidence-dialog.lighter {\n  background-color: rgba(255, 255, 255, 0.95) !important;\n\n  .tred-container-right {\n    background-color: transparent;\n  }\n\n  .el-collapse-item__header, .el-collapse-item__wrap {\n    border-bottom: 1px solid transparent;\n  }\n\n  .el-collapse-item__header, .el-collapse-item__wrap {\n    background-color: transparent;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImageDetailDialog_vue__ = __webpack_require__(4642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__order_image_recapture_detection_mixins__ = __webpack_require__(2801);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ImageDetailDialog: __WEBPACK_IMPORTED_MODULE_3__components_ImageDetailDialog_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__order_image_recapture_detection_mixins__["a" /* default */]],
  data: function data() {
    return {
      search: {
        customerid: null,
        projectid: null,
        batchid: null,
        customer_name: null,
        project_name: null,
        batch_name: null,
        created_at: [],
        result: null
      },
      waitingCnt: 0,
      searchFieldType: {
        result: Number
      },
      dialogImages: [{
        src: null,
        id: null
      }]
    };
  },

  watch: {
    table: function table(val) {
      this.dialogImages = val.map(function (image) {
        return {
          src: image.url,
          id: image.id
        };
      });
    }
  },
  computed: {
    hasCheckOneImage: function hasCheckOneImage() {
      return this.table.some(function (one) {
        return one.checked;
      });
    }
  },
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map([]), {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      var _this = this;

      return request.page('getOrderImageRecaptureDetectionImageTable', params).then(function (data) {
        _this.waitingCnt = data.data.waiting_cnt;
        data.data.data.forEach(function (one) {
          one.checked = false;
        });
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          return resolve(data);
        });
      });
    },
    onExportSearch: function onExportSearch() {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search
      });
    },
    onExportRows: function onExportRows(id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportOrderImageRecaptureDetectionData', params);
        }),
        requestParams: { id: id },
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    onDelete: function onDelete(index, rows) {
      var _this2 = this;

      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', { type: 'warning' }).then(function () {
        request.common('deleteOrderImageRecaptureDetectionData', { id: rows[index].id }).then(function () {
          _this2.$message.success('删除成功');
          rows.splice(index, 1);
        });
      }).catch(function () {
        _this2.$message.info('已取消删除');
      });
    },
    getDotClass: function getDotClass(row) {
      var res = ['image-status-dot'];
      var stateColor = void 0;
      switch (row.result) {
        case 2:
          stateColor = 'suspect';
          break;
        case 3:
          stateColor = 'original';
          break;
        case 4:
          stateColor = 'recaptured';
          break;
      }
      if (stateColor) {
        res.push(stateColor);
      }
      return res;
    },
    openImageDetailDialog: function openImageDetailDialog(index) {
      this.$refs.imageDialog.open(index);
    },
    selectAll: function selectAll() {
      this.table.forEach(function (one) {
        one.checked = true;
      });
    },
    unSelectAll: function unSelectAll() {
      this.table.forEach(function (one) {
        one.checked = false;
      });
    },
    batchSetImageResult: function batchSetImageResult(result) {
      var _this3 = this;

      var imageIds = this.table.filter(function (one) {
        return one.checked;
      }).map(function (one) {
        return one.id;
      });
      request.common('setOrderImageRecaptureDetectionImageStatus', {
        image_ids: imageIds,
        result: result
      }).then(function () {
        _this3.$message.success('设置成功');
        _this3.onSearch();
      });
    },
    setImageStatusBySearch: function setImageStatusBySearch(result) {
      var _this4 = this;

      request.common('setOrderImageRecaptureDetectionImageStatusBySearch', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.search, {
        target_result: result
      })).then(function () {
        _this4.$message.success('设置成功');
        _this4.onSearch();
      });
    }
  })
});

/***/ }),

/***/ 2800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_question_review_question_review_scss__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_question_review_question_review_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__views_question_review_question_review_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_question_review_components_AnswerFileFullScreen_src_ViewImage__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__order_image_recapture_detection_mixins__ = __webpack_require__(2801);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ViewImage: __WEBPACK_IMPORTED_MODULE_1__views_question_review_components_AnswerFileFullScreen_src_ViewImage__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__order_image_recapture_detection_mixins__["a" /* default */]],
  props: {
    images: Array
  },
  data: function data() {
    return {
      index: 0,
      visible: false,
      currentIndex: null,
      imageDetail: {
        image: {
          status: null,
          orderid: null,
          created_at: null,
          operation_logs: []
        },
        step: {},
        customer: {},
        project: {},
        batch: {},
        orderDetail: {}
      },
      statusLabel: null,
      isloadingRightBar: true
    };
  },

  watch: {
    imageDetail: function imageDetail(val) {
      this.statusLabel = this.getStatusLabel(val.image.result);
    }
  },
  methods: {
    open: function open(index) {
      this.visible = true;
      this.index = index;

      this.loadRightBarData(index);
    },
    onImageChanged: function onImageChanged(index) {
      if (this.index !== index) {
        this.loadRightBarData(index);
      }
    },
    loadRightBarData: function loadRightBarData(index) {
      var _this = this;

      this.isloadingRightBar = true;
      var image = this.images[index];
      request.page('getOrderImageRecaptureDetectionImageDetail', { id: image.id }).then(function (_ref) {
        var data = _ref.data;

        _this.index = index;
        _this.imageDetail = data;
        _this.isloadingRightBar = false;
      });
    },
    setImageResult: function setImageResult(result) {
      var _this2 = this;

      request.common('setOrderImageRecaptureDetectionImageStatus', {
        image_ids: [this.imageDetail.image.id],
        result: result
      }).then(function () {
        _this2.$message.success('设置成功');
        _this2.loadRightBarData(_this2.index);
      });
    }
  }
});

/***/ }),

/***/ 2801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    var getStatusLabel = function getStatusLabel(status) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.statusOpts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var one = _step.value;

          if (one.key === status) {
            return one.label;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    };
    return {
      getStatusLabel: getStatusLabel,
      statusOpts: [{ key: 2, label: '疑似翻拍' }, { key: 3, label: '非翻拍' }, { key: 4, label: '确认翻拍' }],
      exportHeader: [{
        text: '客户',
        key: 'customer_name',
        formatter: function formatter(row) {
          return row.customer_name + '/' + row.customerid;
        }
      }, {
        text: '项目',
        key: 'project_name',
        formatter: function formatter(row) {
          return row.project_name + '/' + row.project_number;
        }
      }, {
        text: '批次',
        key: 'batch_name',
        formatter: function formatter(row) {
          return row.batch_name + '/' + row.batch_number;
        }
      }, {
        text: '拍摄时间',
        key: 'created_at'
      }, {
        text: '状态',
        key: 'result',
        formatter: function formatter(row) {
          return getStatusLabel(row.result);
        }
      }, {
        text: '工单id',
        key: 'orderid'
      }, {
        text: '题目标题',
        key: 'step_title'
      }, {
        text: '照片URL',
        key: 'url'
      }]
    };
  }
});

/***/ }),

/***/ 4636:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("368d6933", content, true, {});

/***/ }),

/***/ 4637:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderImageRecaptureDetectionImageTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4638:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4639);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("64ce4cbd", content, true, {});

/***/ }),

/***/ 4639:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".image-box[data-v-0f781d4e]{width:140px;height:140px;margin:15px;cursor:pointer}.image-box[data-v-0f781d4e] img{-webkit-transition:all .6s;transition:all .6s}.image-box[data-v-0f781d4e] img:hover{-webkit-transform:scale(1.5);transform:scale(1.5)}.image-status-dot[data-v-0f781d4e]{width:20px;height:20px;position:absolute;top:15px;right:15px;border-radius:50%;background:#fff}.image-status-dot.suspect[data-v-0f781d4e]{background:#e6a23c}.image-status-dot.original[data-v-0f781d4e]{background:#67c23a}.image-status-dot.recaptured[data-v-0f781d4e]{background:#f56c6c}", "", {"version":3,"sources":["/workspace/src/views/order-image-recapture-detection/pages/OrderImageRecaptureDetectionImageTable.vue"],"names":[],"mappings":"AACA,4BAA4B,YAAY,aAAa,YAAY,cAAc,CAC9E,AACD,gCAAgC,2BAA4B,kBAAmB,CAC9E,AACD,sCAAsC,6BAA6B,oBAAoB,CACtF,AACD,mCAAmC,WAAW,YAAY,kBAAkB,SAAS,WAAW,kBAAkB,eAAe,CAChI,AACD,2CAA2C,kBAAkB,CAC5D,AACD,4CAA4C,kBAAkB,CAC7D,AACD,8CAA8C,kBAAkB,CAC/D","file":"OrderImageRecaptureDetectionImageTable.vue","sourcesContent":["\n.image-box[data-v-0f781d4e]{width:140px;height:140px;margin:15px;cursor:pointer\n}\n.image-box[data-v-0f781d4e] img{-webkit-transition:all 0.6s;transition:all 0.6s\n}\n.image-box[data-v-0f781d4e] img:hover{-webkit-transform:scale(1.5);transform:scale(1.5)\n}\n.image-status-dot[data-v-0f781d4e]{width:20px;height:20px;position:absolute;top:15px;right:15px;border-radius:50%;background:#fff\n}\n.image-status-dot.suspect[data-v-0f781d4e]{background:#E6A23C\n}\n.image-status-dot.original[data-v-0f781d4e]{background:#67C23A\n}\n.image-status-dot.recaptured[data-v-0f781d4e]{background:#F56C6C\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4640:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0ea21a29", content, true, {});

/***/ }),

/***/ 4641:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"OrderImageRecaptureDetectionImageTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageDetailDialog_vue__ = __webpack_require__(2800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_583bfb50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageDetailDialog_vue__ = __webpack_require__(4645);
function injectStyle (ssrContext) {
  __webpack_require__(4643)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-583bfb50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageDetailDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_583bfb50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageDetailDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4643:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4644);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5fde4dea", content, true, {});

/***/ }),

/***/ 4644:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".tred-container[data-v-583bfb50]{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%}.tred-container-left[data-v-583bfb50]{width:calc(100% - 350px);position:relative}.tred-container-right[data-v-583bfb50]{padding:20px;width:350px;overflow:scroll}", "", {"version":3,"sources":["/workspace/src/views/order-image-recapture-detection/components/ImageDetailDialog.vue"],"names":[],"mappings":"AACA,iCAAiC,oBAAoB,oBAAoB,aAAa,WAAW,CAChG,AACD,sCAAsC,yBAAyB,iBAAiB,CAC/E,AACD,uCAAuC,aAAa,YAAY,eAAe,CAC9E","file":"ImageDetailDialog.vue","sourcesContent":["\n.tred-container[data-v-583bfb50]{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%\n}\n.tred-container-left[data-v-583bfb50]{width:calc(100% - 350px);position:relative\n}\n.tred-container-right[data-v-583bfb50]{padding:20px;width:350px;overflow:scroll\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"fullscreen":true,"append-to-body":"","title":"图片查看器","custom-class":"task-review-evidence-dialog dark","visible":_vm.visible},on:{"close":function (){ return this$1.$emit('close'); },"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"tred-container"},[_c('div',{staticClass:"tred-container-left"},[_c('view-image',{ref:"viewImage",attrs:{"visible":_vm.visible,"index":_vm.index,"files":_vm.images,"toolbar":{}},on:{"changeIndex":_vm.onImageChanged}})],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isloadingRightBar),expression:"isloadingRightBar"}],staticClass:"tred-container-right"},[_c('div',[_c('b',[_vm._v("基础信息")]),_vm._v(" "),_c('p',[_vm._v("工单ID: "+_vm._s(_vm.imageDetail.image.orderid))]),_vm._v(" "),_c('p',[_vm._v("客户: "+_vm._s(_vm.imageDetail.customer.name)+"/"+_vm._s(_vm.imageDetail.customer.id))]),_vm._v(" "),_c('p',[_vm._v("项目名称: "+_vm._s(_vm.imageDetail.project.name)+"/"+_vm._s(_vm.imageDetail.project.number))]),_vm._v(" "),_c('p',[_vm._v("批次名称: "+_vm._s(_vm.imageDetail.batch.detail))]),_vm._v(" "),_c('p',[_vm._v("拍摄时间: "+_vm._s(_vm.imageDetail.image.created_at))]),_vm._v(" "),_c('p',[_vm._v("模板标题: Q"+_vm._s(_vm.imageDetail.step.index)+"-"+_vm._s(_vm.imageDetail.step.title))]),_vm._v(" "),_c('p',[_vm._v("提交用户: "+_vm._s(_vm.imageDetail.orderDetail.userid))]),_vm._v(" "),_c('p',[_vm._v("状态: "+_vm._s(_vm.statusLabel))])]),_vm._v(" "),_c('div',[_c('b',[_vm._v("审核日志")]),_vm._v(" "),(_vm.imageDetail.image.operation_logs.length > 0)?_c('div',_vm._l((_vm.imageDetail.image.operation_logs),function(log){return _c('p',[_vm._v(_vm._s(log))])}),0):_c('div',[_c('p',[_vm._v("\n            暂无审核日志。\n          ")])])]),_vm._v(" "),_c('div',[_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.setImageResult(3)}}},[_vm._v("非翻拍")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.setImageResult(4)}}},[_vm._v("确认翻拍")])],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 4646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("翻拍识别")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_vm._v("\n    当前待识别数量： "+_vm._s(_vm.waitingCnt)+"张\n  ")]),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"客户名称","prop":"customer_name"}},[_c('el-input',{attrs:{"placeholder":"请输入客户名称","clearable":""},model:{value:(_vm.search.customer_name),callback:function ($$v) {_vm.$set(_vm.search, "customer_name", $$v)},expression:"search.customer_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目名称","prop":"project_name"}},[_c('el-input',{attrs:{"placeholder":"请输入项目名称","clearable":""},model:{value:(_vm.search.project_name),callback:function ($$v) {_vm.$set(_vm.search, "project_name", $$v)},expression:"search.project_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"批次名称","prop":"batch_name"}},[_c('el-input',{attrs:{"placeholder":"请输入批次名称","clearable":""},model:{value:(_vm.search.batch_name),callback:function ($$v) {_vm.$set(_vm.search, "batch_name", $$v)},expression:"search.batch_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"拍摄时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","clearable":"","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"result"}},[_c('el-select',{attrs:{"clearable":""},model:{value:(_vm.search.result),callback:function ($$v) {_vm.$set(_vm.search, "result", $$v)},expression:"search.result"}},_vm._l((_vm.statusOpts),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.key}})}),1)],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onExportSearch}},[_vm._v("按搜索导出\n        ")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.setImageStatusBySearch(3)}}},[_vm._v("按搜索结果置为非翻拍")])],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.selectAll}},[_vm._v("全选")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.unSelectAll}},[_vm._v("全不选")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"mini","disabled":!_vm.hasCheckOneImage},on:{"click":function($event){return _vm.batchSetImageResult(3)}}},[_vm._v("批量置为非翻拍")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini","disabled":!_vm.hasCheckOneImage},on:{"click":function($event){return _vm.batchSetImageResult(4)}}},[_vm._v("批量置为确认翻拍")])],1),_vm._v(" "),_c('div',_vm._l((_vm.table),function(image,index){return _c('div',{staticStyle:{"position":"relative","display":"inline-block"}},[_c('el-image',{staticClass:"image-box",attrs:{"src":_vm._f("ossThumbnail")(image.url,140),"fit":"fill"},on:{"click":function($event){$event.stopPropagation();return _vm.openImageDetailDialog(index)}}}),_vm._v(" "),_c('el-checkbox',{staticStyle:{"position":"absolute","left":"-5px","top":"15px","transform":"scale(1.3)"},model:{value:(image.checked),callback:function ($$v) {_vm.$set(image, "checked", $$v)},expression:"image.checked"}}),_vm._v(" "),_c('div',{class:_vm.getDotClass(image)})],1)}),0),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('image-detail-dialog',{ref:"imageDialog",attrs:{"images":_vm.dialogImages},on:{"close":_vm.onRefresh,"refresh":_vm.onRefresh}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-image-recapture-detection-table.25f3566862a3656b6048.js